// This file is automatically generated.
// Do not edit this file manually, use the script createLocales.js!

/* eslint-disable quotes */
/* eslint-disable indent */

export default {
  "__vendor__": "mtf",
  "devise": {
    "failure": {
      "bad_request": "Datos erróneos. Por favor, inténtelo de nuevo.",
      "already_registered": "Este correo electrónico ya está en uso. Se ha enviado un mensaje con un enlace de activación de su cuenta a su correo electrónico. Compruebe sus mails y active su cuenta.",
      "timeout": "Su sesión expiró, por favor inicie sesión nuevamente para continuar.",
      "forbidden": "Prohibido",
      "invalid": "Email o contraseña inválidos.",
      "username": {
        "already_in_use": "Este nombre de usuario ya existe!"
      },
      "email": {
        "already_in_use": "Este correo electrónico ya está en uso."
      },
      "already_activated": "Si su correo existe en nuestra base de datos, va a recibir un correo con instrucciones sobre cómo recuperar su cuenta en unos pocos minutos."
    },
    "mailer": {
      "confirmation_instructions": {
        "subject": "Instrucciones de confirmación"
      },
      "reset_password_instructions": {
        "subject": "Instrucciones de recuperación de contraseña"
      }
    },
    "confirmations": {
      "send_instructions": "Va a recibir un correo con instrucciones sobre cómo confirmar su cuenta en unos pocos minutos.",
      "send_instructions_paranoid": "Si se ha registrado en VBus.net, recibirá un correo electrónico en pocos minutos con el que podrá confirmar su registro. Por favor, compruebe su buzón de correo electrónico."
    },
    "passwords": {
      "updated_not_active": "Su contraseña fue cambiada.",
      "send_paranoid_instructions": "Si su correo existe en nuestra base de datos, va a recibir un correo con instrucciones sobre cómo resetear su contraseña en su bandeja de entrada."
    },
    "registrations": {
      "destroyed": "Fue grato tenerle con nosotros. Su cuenta fue cancelada."
    }
  },
  "general": {
    "welcome": "Bienvenidos",
    "yourProAccount": "Su acceso VBus.net PRO",
    "hello": "Hola",
    "greetings": "Saludos cordiales",
    "vbusnetTeam": "Su equipo VBus.net",
    "errorInvalidCharacters": "Caracteres no válidos",
    "emailUnsubscribed": "Su dirección de correo electrónico ha sido eliminada con éxito.",
    "emailAlreadyUnsubscribed": "Su dirección de correo electrónico ya ha sido eliminada.",
    "newDevice": "Nuevo equipo",
    "isFriend": "Compartir",
    "backup": {
      "error": {
        "file": "Archivo de copia de seguridad no es válido o está deteriorado!",
        "fileMatchSystem": "El archivo de copia de seguridad no se adapta al sistema seleccionado"
      },
      "choose": {
        "file": "Seleccione archivo de copia de seguridad…"
      },
      "restore": "Restaurar copia de seguridad",
      "successful": "Sus datos han sido correctamente restaurados.",
      "name": "Copia de seguridad",
      "create": "Crear copia de seguridad",
      "text1": "Aquí encontrará un resumen de sus datos. Seleccione los puntos deseados para ser guardados. Si selecciona un sistema a tiempo real, diagrama o descarga, se guardaran también todos los filtros e imágenes correspondientes.",
      "file": "Archivo de copia de seguridad",
      "text2": "A continuación, se enumeran todos los datos de la copia de seguridad. Puede restaurar todos los datos o los datos seleccionados. Si selecciona un sistema a tiempo real, diagrama o descargar, se restauraran también todos los filtros e imágenes correspondientes.",
      "fileType": "El archivo debe ser un archivo válido de copia de seguridad de VBus.net!",
      "text3": "Sus datos han cambiado desde que se ha creado la copia de seguridad! Esto puede ocurrir si se han conectado dispositivos nuevos o dispositivos existentes se han quitado o reconectado.Por favor, tenga en cuenta que después de restaurar, la atribución de filtro puede ser incorrecta.",
      "visualization": "Datos de visualización de la copia de seguridad"
    },
    "days": "Días",
    "entryNotFound": "No se ha encontrado ninguna entrada.",
    "allValues": "Todos los valores",
    "unknown": "Desconocido",
    "from": "De",
    "to": "Hasta",
    "customRange": "Período elegido por usuario",
    "name": "Nombre",
    "unit": "Unidades",
    "color": "Color",
    "format": "Formato",
    "errorTryAgain": "Ha ocurrido un error. Por favor, inténtelo de nuevo más tarde …",
    "interestedInProducts": "Gracias por su interés en nuestros productos.",
    "ok": "OK",
    "currentAccount": "Acceso actual",
    "newInvalidDate": "Nueva fecha de expiración",
    "KontaktformularKenntnis": "He tomado nota del __PRIVACY_POLICY__. Acepto que mis indicaciones y mis datos serán recopilados y almacenados electrónicamente para responder a mi solicitud.",
    "interval": "Intervalo",
    "minute": "Minuto",
    "minutes": "minutos",
    "monday": "Lunes",
    "tuesday": "Martes",
    "wednesday": "Miércoles",
    "thursday": "Jueves",
    "friday": "Viernes",
    "saturday": "Sábado",
    "sunday": "Domingo",
    "displayValue": "Mostrar valor",
    "conversions": "Conversiones",
    "add": "añadir",
    "displayUnit": "Mostrar unidad",
    "none": "Ninguno",
    "close": "Cerrar",
    "apply": "Utilizar",
    "note": "NOTA",
    "deleteIrrevocably": "Los datos serán eliminados irrevocablemente!",
    "delete": "Borrar",
    "errors": "Errores ",
    "noErrors": "No existen errores",
    "error": "Error",
    "deleted": "¡Borrada!",
    "entryDeleted": "La entrada ha sido borrada.",
    "save": "Guardar",
    "edit": "Modificar",
    "status": "Estado",
    "cancel": "Cancelar",
    "weiter": "Siguiente",
    "yesDelete": "Sí, borrar",
    "no": "No",
    "configurationDeleted": "La configuración ha sido borrada.",
    "selectAll": "Seleccionar todo",
    "unselectAll": "Deseleccionar todo",
    "download": "Descarga",
    "prefix": "Prefijo",
    "subscription": "Acceso",
    "information": "Información",
    "passwordCurrent": "Contraseña actual",
    "languageForEmail": "Idioma (E-mails)",
    "defaultUnits": "Unidades estándar ",
    "dateFormat": "Formato de fecha",
    "myPersonalSettings": "Mis datos personales",
    "changeYourPassword": "Cambiar la contraseña",
    "login": "Iniciar sesión",
    "newPassword": "Nueva contraseña",
    "passwordLength": "debe ser por lo menos 6 caracteres",
    "passwordConfirmNewPassword": "Confirmar nueva contraseña",
    "forgotYourPassword": "¿Olvidó su contraseña?",
    "passwordDifferent": "¡Las dos contraseñas no coinciden!",
    "password": "Contraseña",
    "nameResolRegler": "Regulador RESOL",
    "pleaseChoose": "Por favor, elija",
    "invalidCharacters": "Caracteres no válidos",
    "chooseLanguage": "Elija el idioma",
    "langGerman": "Alemán",
    "langEnglish": "Inglés",
    "langFrench": "Francés",
    "langItalian": "Italiano",
    "langSpanish": "Español",
    "langSuomi": "Finés",
    "showDiagram": "Mostrar el diagrama",
    "diagramTitle": "Título del diagrama",
    "publicLink": "Enlace público",
    "loadingData": "Cargando datos, por favor espere",
    "saving": "Guardando",
    "yourLiveData": "Sus datos en tiempo real",
    "warningNoLivedata": "No está disponible el valor a tiempo real!",
    "noResults": "¡Su selección no ha dado ningún resultado!",
    "removeAll": "Eliminar todo",
    "undo": "Deshacer",
    "originalNamesValues": "Nombres y valores originales",
    "conversionAvailable": "Conversión disponible",
    "maxAllowedFilterValues": "¡El filtro tiene más valores de los permitidos! Un datalogger de muestra puede contener un máximo de 10 valores de filtro. Al guardar, solo se guardan los primeros 10 valores de filtro.",
    "filterDeleted": "El filtro ha sido borrado.",
    "showCustomImages": "Imágenes personalizadas",
    "imageDeleted": "La imagen ha sido borrada.",
    "system": "Sistema",
    "autoscaleDescription": "Ajuste las dimensiones del sistema a tiempo real a la máxima resolución de la pantalla.",
    "lastSent": "Último envío",
    "on": "el",
    "language": "Idioma",
    "active": "activo",
    "inactive": "inactivo",
    "daily": "Diariamente",
    "weekly": "Semanalmente",
    "monthly": "Mensualmente",
    "settings": "Configuración general",
    "online": "Conectado",
    "offline": "Desconectato",
    "confirmed": "confirmado",
    "notConfirmed": "no confirmado",
    "demo": "Muestra",
    "accessDatalogger": "¡El acceso para VBus.net se puede encontrar en la interfaz web de su datalogger!",
    "loginDatalogger": "Por favor, inicie la sesión en la interfaz web de su datalogger y active el acceso en:",
    "settingsDatalogger": "Configuración / Acceso remoto / Acceso a través de Internet",
    "timezone": "Huso horario",
    "location": "Ubicación",
    "geodata": "Coordenadas",
    "search": "Búsqueda",
    "change": "Cambio",
    "advancedSettings": "Ajustes avanzados",
    "visuaEnablingVbusnet": "VBus.net se conecta a su datalogger o módulo de comunicación en intervalos regulares para cargar los datos actuales. Esto utiliza el volumen de datos y la velocidad de transferencia de su acceso a Internet. Si no quiere que esto suceda, puede desactivar el tráfico de datos aquí. Tenga en cuenta que no se recuperarán datos nuevos de VBus.net y que los datos históricos no serán sincronizados por VBus.net posteriormente.",
    "userComments": "Comentarios del usuario",
    "adminComments": "Comentarios del admin",
    "accessToken": "Código de acceso",
    "claimDevice": "Añadir un equipo",
    "yes": "Sí",
    "firmware": "Firmware ",
    "serial": "Número de serie",
    "enabled": "Autorizado ",
    "disabled": "No autorizado",
    "userComment": "Comentario del usuario",
    "defaultSettings": "Ajustes generales",
    "controller": "Regulador",
    "interface": "Interfaz",
    "technicalData": "Datos técnicos",
    "privatePerson": "Persona particular",
    "topic": "Tema",
    "yourName": "Su nombre",
    "addNoticeSing": "Nota",
    "sendAdditionalInformation": "Send additional information for easier support",
    "Einwilligung": "Consentimiento en virtud de la ley de protección de datos",
    "KontaktformularHinweis": "Puede revocar su consentimiento en cualquier momento para el futuro por correo electrónico a datenschutz@dvm-cloud.net",
    "send": "Enviar",
    "feedbackText": "General feedback",
    "improvement": {
      "proposal": "Improvement proposal"
    },
    "nameTechnicalSupport": "Asistencia técnica",
    "question": "Question",
    "hervorragend": "excellent",
    "gut": "good",
    "neutral": "neutral",
    "ausreichend": "sufficient",
    "unzureichend": "insufficient",
    "kinderleicht": "very easy",
    "intuitiv": "intuitive",
    "kompliziert": "complicated",
    "nichtbedienbar": "not operable",
    "unverzichtbar": "indispensable",
    "sehrhilfreich": "very useful",
    "teilweisenuetzlich": "partly useful",
    "unbrauchbar": "useless",
    "sendResetPasswordInstructions": "Envíeme instrucciones para cambiar la contraseña",
    "nameTechnicalSupportTime": "De lunes a viernes de 10:00 a 18:00 ",
    "feedbackName": "Feedback",
    "feedback": "Formulario de feedback",
    "ImpressumAngaben": "Información de acuerdo con el § 5 de la Ley Alemana de Telemedia (TMG)",
    "Streitschlichtung": "Resolución de disputas",
    "StreitschlichtungText": "No estamos dispuestos u obligados a participar en procedimientos de resolución de disputas ante una junta de arbitraje de consumidores.",
    "StreitschlichtungAllgemein": "Junta General de Arbitraje del Consumidor:",
    "nameDataloggerKomm": "Datalogger / Módulo de communicación",
    "nameRouter": "Router",
    "Versionsvergleich": "BASIC versus PRO",
    "year": "Año",
    "passwordConfirmation": "Confirmación de contraseña",
    "Pflichtfelder": "Los campos marcados con * son obligatorios",
    "resendConfirmationInstuctions": "Enviar de nuevo el e-mail de confirmación",
    "back": "Volver",
    "years": "Años",
    "basicLiveSystemText": "Con el Live System Editor puede mostrar fácilmente los datos seleccionados de su instalación en una imagen del sistema. Arrastre y suelte los datos en la posición deseada y coloque símbolos prefabricados como acumulador y válvulas en la imagen del sistema. Los datos se actualizan automáticamente cada 5 minutos sin necesidad de recargar la página.",
    "basicConnectionText": "VBus.net permite un acceso fácil y seguro a su sistema, sin ninguna instalación de software compleja o conocimiento de la red.",
    "freeBasicFunctions": "Funciones básicas gratis",
    "basicLiveDataText": "Los datos en tiempo real de su sistema se pueden mostrar en una tabla clara de esta manera usted obtendrá todos los valores medidos actuales de un vistazo.",
    "basicDiagrammeText": "Los datos guardados se pueden mostrar en forma de diagrama y se pueden diseñar individualmente.",
    "GeplanteDownloadsText": "Reciba regularmente y de forma automática los datos almacenados de su instalación por correo electrónico. Puede seleccionar períodos y, por ejemplo, especificar otros destinatarios.",
    "ReporteText": "Reciba por correo electrónico informes configurables individualmente sobre el estado del sistema de energía solar.",
    "GeraetTeilenText": "Comparta su aparato con otros usuarios de VBus.net, p.ej., con su instalador o asesor de energía con fines informativos y de mantenimiento.",
    "SystemEditorText": "Utilice muchas otras funciones de edición para diseñar individualmente su sistema en tiempo real e integrar sus propias imágenes de componentes y gráficos de sistema.",
    "SicherungText": "La configuración de visualización de VBus.net puede ser guardada y restaurada con unos pocos clics.",
    "FehlerprotokollText": "Esta función proporciona una descripción general de los errores que se han producido en su sistema y le permite buscar errores rápida y fácilmente.",
    "BenachrichtigungenText": "Puede utilizar esta función para enviar notificaciones de correo electrónico libremente definibles a grupos de destinatarios específicos, por ejemplo, para mensajes de error.",
    "ParametrisierenText1": "Parametrice el regulador de forma remota a través de su navegador de Internet. Guarde las configuraciones directamente en VBus.net y cárguelas en su regulador si es necesario.",
    "basicText1": "Pruebe VBus.net - La versión básica es gratuita y una vez que se haya registrado podrá contar con un datalogger de muestra inmediatamente. Vea los datos en un sistema en tiempo real o vea los datos guardados en un diagrama.",
    "basicConnection": "Acceso seguro a su sistema",
    "basicLiveSystem": "Sistemas en tiempo real",
    "basicLiveData": "Visualizar datos en tiempo real",
    "basicDiagramme": "Diagramas",
    "proFunctions": "Las funciones PRO de un vistazo",
    "logout": "Finalizar sesión",
    "Funktionsbeschreibung": "Descripción de funciones",
    "kommunikationsmodulKM2": "Módulo de comunicación KM2",
    "dataloggerDL2": "Datalogger DL2",
    "dataloggerDL3": "Datalogger DL3",
    "Informations": "Información",
    "tools": "Herramientas",
    "rechtliches": "Cuestiones jurídicas",
    "products": "Productos",
    "preferences": "Configuración",
    "menutype": "Navegación rápida",
    "Visualisieren": "Visualización",
    "Ueberwachen": "Control",
    "vbusnetRequirements": "Requisitos para VBus.net",
    "vbusnetRequirementsText": "Para utilizar VBus.net, su regulador RESOL con interfaz de datos VBus® solo debe estar conectado a Internet a través de un datalogger (DL2/DL3) o a través de un módulo de comunicación (KM2). No se precisa ninguna instalación de software complicada.",
    "VisualisierenText1": "Con las posibilidades de visualización de VBus.net siempre tendrá los datos de su instalación a la vista.",
    "VisualisierenText2": "Visualice sus datos en un gráfico de sistema claro o cree diagramas para ver los datos de su instalación en el transcurso de un día, semana o mes.",
    "UeberwachenText1": "Controle su instalación fácilmente con informes y notificaciones automáticas.",
    "UeberwachenText2": "Infórmese periódicamente por correo electrónico sobre el estado de su sistema de energía solar. De este modo, siempre estará al día y podrá reaccionar de inmediato en caso de que se produzca un problema. Detecte problemas con antelación ̶ Configure informes y envíelos al instalador para analizar los errores.",
    "ParametrisierenText2": "Actualmente se soportan los siguientes reguladores solares y de sistema:",
    "proAccountRequired": "¡Se requiere un acceso PRO!",
    "inviteFriend": "Compartir equipo",
    "Parametrisieren": "Parametrización",
    "indexPortal": "El portal para su sistema de calefacción y energía solar",
    "schnittstellenadapter": "¡El adaptador de interfaz VBus®/LAN no es compatible con VBus.net!",
    "km2": {
      "title": "Solución económica para el acceso remoto al controlador",
      "text": "El módulo de comunicación KM2 es la interfaz ideal entre internet y un controlador solar o calefacción. En sólo unos pocos pasos, el regulador RESOL puede conectarse al portal de internet  VBus.net. El módulo de comunicación es adecuado para todos los controladores con VBus® y permite el acceso fácil y seguro a los datos del sistema a través de VBus.net. El acceso remoto a su regulador RESOL también es posible, por supuesto, a través de la herramienta de parametrización RESOL RPT."
    },
    "dl2": {
      "title": "Datalogger DL2 – Acceso remoto al regulador y registro de datos integrados",
      "text": "Acceso remoto al regulador y registro de datos integrados. El Datalogger DL2 es la interfaz entre Internet y un regulador RESOL y además permite el registro de datos del sistema. El DL2 permite el acceso a los datos del sistema a través de www.VBus.net."
    },
    "dl3": {
      "title": "Datalogger DL3 – Registro de datos con una amplia gama de funciones",
      "text": "Registro de datos con una amplia gama de funciones. El Datalogger DL3 se utiliza para el registro de datos de hasta 6 reguladores RESOL y permite la visualización a través de www.VBus.net y la parametrización mediante RESOL RPT. Obtener una visión global de todos los reguladores conectados con la gran pantalla gráfica, todos los ajustes importantes pueden ajustarse directamente en el DL3. El sensor integrado y entradas de impulso pueden medir y registrar temperaturas, incluso sin un controlador. Además, el DL3, está equipado con una funcionalidad de BACnet para conformar la transmisión de datos BACnet y por lo tanto poder ser utilizado en un sistema de gestión de edifcios."
    },
    "profitPro": "Benefíciese de todas las funciones de VBus.net y solicite su acceso PRO.",
    "Funktionsvergleich": "Comparación de funciones",
    "danke": "RESOL le da las gracias",
    "team": "Su equipo RESOL",
    "errorRequired": "¡__Feld__ es obligatorio!",
    "errorInvalid": "¡__Feld__ contiene errores!",
    "errorNotEqual": "¡__Feld__ es erróneo!",
    "collapse": {
      "all": "Cerrar todos"
    },
    "expand": {
      "all": "Abrir todos"
    },
    "help": "Ayuda",
    "loading": "Cargando",
    "data": "Datos",
    "notice": "Nota",
    "quickDiagram": "Diagrama rápido",
    "quickDownload": "Descarga rápida",
    "saved": "Guardado",
    "unknow": "Desconocido",
    "warning": "Advertencia",
    "upload": "Cargar",
    "uploadCustomImage": "Cargar su propia imagen ",
    "version": "Versión",
    "device": "Equipo",
    "own": {
      "name": "Nombre personalizado"
    },
    "getFullVersion": "Versión completa",
    "limitations": "Límite de uso",
    "filter": "Obligatorio",
    "addNote": "Indicación suplementaria",
    "contactAdr": "Dirección personal",
    "loggedInAs": {
      "prefix": "Conectado como",
      "suffix": "No es usted?"
    },
    "actions": "Acciones",
    "tip": "CONSEJO",
    "info": "Información",
    "link": "Enlace",
    "register": "Registrarse",
    "or": "o",
    "and": "y",
    "rememberMe": "Dejar abierta la sesión",
    "changeMyPassword": "Cambiar mi contraseña",
    "wrongEmailOrPassword": "E-mail o contraseña erróneo(a)",
    "newOwnership": "Nuevo equipo",
    "alert": "Aviso",
    "update": "Actualización",
    "comments": "Comentarios",
    "videos": "Videos",
    "downloads": "Downloads",
    "dokumente": "Documentos",
    "datenblatt": "Hoja técnica",
    "montageanleitung": "Manual de instalación",
    "filtern": "filtro",
    "type": "Tipo",
    "until": "hasta",
    "datapoint": "Punto de dato",
    "seconds": "segundos",
    "hours": "horas",
    "position": "Posición",
    "move": "mover ",
    "billingAdr": "Dirección de facturación",
    "billingAdrAdd": "(si es diferente de la dirección de contacto).",
    "terminateFriend": "Retirar el acceso al equipo",
    "myFriends": "Mis equipos compartidos",
    "custom": "definido por el usuario",
    "continuous": "Continuamente (24h/d)",
    "immediately": "inmediatamente",
    "notificationPeriod": "Periodo de notificación",
    "monitoringPeriod": "Periodo de monitorización",
    "latitude": "Latitud",
    "longitude": "Longitud",
    "abbreviation": {
      "example": "Ejemplo"
    },
    "price": "Precio",
    "functions": "Funciones",
    "required": "Necesario",
    "errorReport": "Informe erróneo",
    "permanent": "ilimitado",
    "at": "a las",
    "oClock": "horas",
    "unsubscribed": "anulado",
    "every": "cada",
    "pixel": "Píxeles",
    "lagging": "Estimado cliente,<br><br>La conexión a VBus.net es actualmente muy lenta.<br>Estamos solucionando el problema. Rogamos disculpe las molestias causadas. Gracias por su paciencia.<br><br>Su equipo Vbus.net",
    "offset": "Calibrar",
    "defaults": "Configuración predeterminada",
    "deleteAll": "Eliminar todo",
    "mustSelectOneOption": "Tiene que seleccionar al menos una opción! ",
    "browserNotSupported": "Su navegador no es compatible!<br/>Por favor actualice a una versión reciente.",
    "uploadErrorFile": "El archivo no puede ser subido!",
    "errorSensor": "Fallo de sonda",
    "new": "nuevo",
    "energyOffset": "Compensación del valor de energía",
    "weatherData": "Información metereológica de se ubicación",
    "gridLiveSystem": "Patrón en cuadrícula para el posicionamiento más sencillo. ",
    "dailyEnergyValues": "Resumen diario del valor de energía.",
    "overwriteWarning": "Los datos existentes se sobreescribirán!",
    "maxFilesize": "Tamaño máximo del archivo",
    "factor": "Factor",
    "removeConversions": "Quite las conversiones",
    "chooseAltUnit": "Elija una unidad alternativa…",
    "content": "Contenidos",
    "additionalContent": "Más contenidos",
    "choseContent": "Sellecionar contenidos",
    "publicLinkDiagrams": "Enlaces públicos a diagramas",
    "publicLinkSchemes": "Enlaces públicos a sistemas a tiempo real",
    "deviceInfo": "Información del equipo",
    "noEnergyValuesInFilter": "El filtro seleccionado no contiene los valores de la energía!",
    "warningSelectOnValue": "Tienes que seleccionar al menos el valor de un filtro!",
    "heatQuantityDay": "Cantidad de calor diaria",
    "heatQuantityWeek": "Cantidad de calor semanal",
    "heatQuantityMonth": "Cantidad de calor mensual",
    "heatQuantityTotal": "Cantidad de calor total",
    "errorMessages": "Mensajes de error",
    "temperatureValuesIn": "Valores de temperatura en",
    "operator": "Operador",
    "systemType": "Tipo de sistema",
    "showLiveSystem": "Mostrar el sistema a tiempo real",
    "confirmationMail": "Confirmación de correo electrónico",
    "noConfirmationMailreceived": "¿No ha recibido un correo electrónico de confirmación?",
    "backupHintReceivers": "El e-mail de confirmación ha de enviarse manualmente a todos los destinatarios.",
    "notificationInterval": "Intervalo de notificación",
    "oneEnergyInFilter": "El filtro debe contener al menos un valor de energía!",
    "iUnderstand": "Yo entiendo.",
    "useCookies": "Esta página web utiliza cookies.",
    "whatsNew": "¿Qué novedades?",
    "nameTelefon": "Teléfono: +34 96 091 53 99",
    "nameFax": "Fax: +34 96 111 92 73",
    "nameEmail": "info@dvm-cloud.net",
    "slide1": "Los diagramas individuales",
    "slide2": "Sistemas a tiempo real",
    "slide3": "Informes automáticos vía correo electrónico",
    "slide4": "¿Cómo funciona?",
    "nextSteps": "Siguientes pasos",
    "clickHereForMoreInformation": "Haga clic aquí para obtener más información...",
    "clickHere": "Haga click aquí…",
    "learnMore": "Haga click aquí para conocer más…",
    "firstSteps": "Primeros pasos en VBus.net",
    "deviceName": "Nombre del equipo",
    "forWeatherData": "De datos meteorológicos",
    "dataloggerOrCommunicationModule": "Datalogger DL2/DL3 o un Módulo de comunicación KM2",
    "downloadComplete": "Descarga completa",
    "automaticallyConfirmed": "Su cuenta de e-mail (en Mi perfil) será automaticamente activada. Los nuevos destinatarios tienen que confirmar la recepción.",
    "downloaded": "descargado",
    "templates": "Plantillas",
    "template": "Plantilla ",
    "addTemplate": "Añadir plantilla",
    "noTemplateAvailable": "No hay plantilla disponible para este sistema. ",
    "templateAdded": "La plantilla se ha añadido correctamente. ",
    "channel": "Canal",
    "vbusConnection": "Conexión VBus",
    "optional": "opcional",
    "unknownError": "Se ha producido un error desconocido",
    "menuLanguage": "Menú Idioma",
    "reloadPageNow": "Vuelva a cargar esta página ahora",
    "noDevicesFound": "No se han encontrado dispositivos en VBus",
    "Haftungsausschluss": "Exención de responsabilidad",
    "PrivacyPolicy": "Política de privacidad",
    "TermsOfUse": "Condiciones generales",
    "Verantwortlich55RStV": "Responsable de los contenidos según § 55 Abs. 2 RStV (Acuerdo de radiodifusión interestatal Alemán)",
    "UmsatzsteuerIdUg": "Número de identificación fiscal de ventas de acuerdo con el § 27 una ley de impuestos a las ventas",
    "VertGeschFuehrer": "Gerente",
    "DsgvoStart": "El 25 de mayo de 2018 entra en vigor el nuevo Reglamento General de Protección de Datos (RGPD).",
    "DsgvoStarted": "El 25 de mayo de 2018 entró en vigor el nuevo Reglamento General de Protección de Datos (RGPD).",
    "DsgvoText": "El RGPD contiene amplias prescripciones y requisitos de información para el procesamiento y la protección de datos personales. ",
    "acceptEulaMessage": "Aceptar condiciones de uso y política de privacidad",
    "weather": "Tiempo",
    "other": "Otros",
    "fullscreen": "Pantalla completa",
    "createFilterFirst": "Primero debe crear un filtro...",
    "deviceFilter": "Filtro para aparatos",
    "filterLisyByOnlineStatus": "Filtrar la lista por estado online",
    "filterLisyByDeviceType": "Lista de filtros por tipo de aparato",
    "sorting": "Clasificación",
    "noDataLoaded": "No se ha podido cargar ningún dato ¡por favor, vuelva a cargar la página!",
    "showLegend": "Mostrar leyenda",
    "symbol": "El símbolo",
    "chooseHeatQuantities": "Puede seleccionar hasta 3 cantidades de calor",
    "twoFactorAuthentication": "Autenticación de dos factores (2FA)",
    "faq": "Preguntas frecuentes",
    "copyToClipboard": "Copiar al portapapeles",
    "worst": "Muy deficiente",
    "bad": "Deficiente",
    "weak": "No segura",
    "good": "Segura",
    "strong": "Muy segura",
    "automaticUpdate": "Actualización automática en __SECONDS__ segundos",
    "axisSettings": "Ajustes de eje",
    "engaged": "On",
    "off": "Off",
    "setup2FA": "Configurar la autenticación de dos factores",
    "remove2FA": "Quitar la autenticación de dos factores",
    "setupShort2FA": "Configurar la autenticación de dos factores (2FA)",
    "removeShort2FA": "Quitar la autenticación de dos factores (2FA)",
    "recovery2FA": "Códigos de recuperación",
    "qr2FA": "Código QR",
    "authenticator2FA": "Código de autenticación",
    "code12FA": "Los códigos de recuperación se pueden utilizar para acceder a su cuenta VBus.net si no tiene acceso a su aplicación de autenticación de dos factores.",
    "code22FA": "Trate los códigos de recuperación con la misma atención que prestaría a su contraseña. Le recomendamos que los guarde en un gestor de contraseñas.",
    "code32FA": "Los códigos de recuperación solo se pueden utilizar una sola vez para iniciar una sesión. Después de un inicio de sesión satisfactorio, estos pierden su validez.",
    "code42FA": "Guarde o imprima sus códigos de recuperación antes de proceder con la configuración de autenticación de dos factores.",
    "code52FA": "¡Si pierde sus códigos de recuperación y ya no tiene acceso a su aplicación de autenticación de dos factores, ya no podrá iniciar una sesión!",
    "print": "Imprimir",
    "code62FA": "Por favor, escanee el código de barras con su aplicación de autenticación. A continuación, haga clic en SIGUIENTE.",
    "code72FA": "Por favor, introduzca el código de su aplicación de autenticación y haga clic en FINALIZAR.",
    "finish": "Finalizar",
    "invalid2FA": "El código de autenticación introducido no es válido. Por favor, inténtelo de nuevo.",
    "success2FA": "¡La autenticación de dos factores se ha configurado correctamente!",
    "examples": "Ayuda",
    "notPossibleMobile": "¡Esta función no está disponible en un dispositivo móvil!",
    "dateAndTime": "Fecha y hora",
    "deviceOverview": "Descripción general del aparato",
    "deviceMap": "Mapa de ubicación del aparato",
    "minimumSize": "Tamaño mínimo",
    "maximumSize": "Tamaño máximo",
    "activation": "Activar",
    "switchToPro": "Cambie ahora al acceso PRO",
    "documentNotFound": "Desgraciadamente, el documento en cuestión no se encuentra en nuestro servidor.",
    "startPage": "Página de inicio",
    "clear": "Reset",
    "helpAndSupport": "Ayuda y soporte",
    "fileUpload": "Subir archivo",
    "fileUploadText": "El archivo __FILENAME__ se está cargando en el servidor. Por favor, espere...",
    "unsupportedFileType": "¡El tipo de archivo no es compatible!",
    "invalidCharactersFilename": "¡El nombre del archivo no debe contener caracteres especiales o diéresis!",
    "invalidFileSize": "¡El archivo es demasiado grande! (máx. 15 MB)",
    "errorLoadData": "¡Error al cargar los datos!",
    "unknownExceptionError": "Error de excepción desconocido",
    "demoDevice": "Aparato de muestra",
    "friendDevice": "Aparato compartido",
    "temperatureSensor": "Sensor de temperatura",
    "switch": "Interruptor",
    "alreadyClaimedDemo": "Ya ha añadido un datalogger a su cuenta de usuario.",
    "function": "Función",
    "convertValue": "Convertir valor",
    "tokenNotWorking": "Lo sentimos que no haya funcionado. Pruebe con un token/cupón diferente.",
    "divisionByZero": "¡División por 0!",
    "passwordStrength": "Seguridad de contraseña",
    "chartType": "Tipo de diagrama",
    "autoscale": "Escalado automático",
    "time": "Hora",
    "factoryDefault": "Ajuste de fábrica",
    "initialize": "Inicialización",
    "addDataloggerCommunicationModule": "",
    "twoFactorRemovedSuccessful": "",
    "hideLegend": "",
    "warningUnknownLivedata": "",
    "default": "",
    "passwordIsEmail": "",
    "unknownDevice": "",
    "noSettingsAvailable": "",
    "errorLoadImage": "",
    "errorLoadWeather": "",
    "errorLoadLiveSystem": "",
    "weekday": "",
    "createdAt": "",
    "tooltip": "",
    "subtitle": "",
    "lastUpdated": "",
    "preview": "",
    "extendSubscription": "",
    "loginToExtendSubscription": "",
    "orderedSubscription": "",
    "yourAccount": "",
    "unlimited": "",
    "emailAlreadyExists": "",
    "selectDecices": "",
    "description": "",
    "decimals": "",
    "needInvoice": "",
    "proAccount": "",
    "businessAccount": "",
    "convertFilterValue": "",
    "doNotShowAgain": "",
    "toggle": "",
    "numberFormat": "",
    "checkVBusConnection": "",
    "liveDataNotUpToDate": "",
    "news": "",
    "hide": "",
    "archive": "",
    "noNewMessages": "",
    "messages": "",
    "viewArchivedMessages": "",
    "readNow": "",
    "customerOpinions": "",
    "globalErrorTitle": "",
    "globalErrorMessage": "",
    "globalSuccessTitle": "",
    "globalSuccessMessage": "",
    "endOfQuarter": "",
    "lastQuarter": "",
    "licenseText": "",
    "invalidToken": "",
    "selectDay": "",
    "selectCalendarWeek": "",
    "selectMonth": "",
    "selectYear": "",
    "calendarWeek": "",
    "calendarWeekShort": "",
    "selectQuarter": "",
    "dataloggerDL2Plus": "Datalogger DL2 Plus",
    "geodataFormatDecimal": "",
    "geodataFormatSexagesimal": "",
    "noData": "",
    "automaticConversion": ""
  },
  "vbusnet": {
    "email": {
      "confirmText": "El siguiente enlace le permite confirmar su cuenta:",
      "confirmMyAccount": "Confirmar mi cuenta",
      "requestNewPassword": "Alguien ha solicitado un enlace para cambiar la contraseña. Si desea cambiar la contraseña, haga clic en el siguiente enlace.",
      "changeMyPassword": "Cambiar mi contraseña",
      "didNotRequestThisText": "Si no es usted quien ha solicitado el enlace, no tenga en cuenta este e-mail.",
      "passwordWontChangeText": "Su contraseña seguirá siendo la misma a menos que haga clic en el siguiente enlace para crear una nueva contraseña."
    },
    "demo_ownership_description": "Este datalogger de muestra pone a su disposición los datos de una instalación de energía solar térmica y calefacción situada en el oeste de Alemania. Los datos VBus los más interesantes son:",
    "demo_datalogger": "El datalogger solo tiene opciones de edición limitadas."
  },
  "visualization": {
    "scheduledDownloadBodyAttachment": "Adjunto a este correo electrónico encontrará su descarga programada.",
    "scheduledDownloadBodyNoAttachment": "Este correo electrónico no contiene ninguna descarga programada. Probablemente no hay datos para el período seleccionado.",
    "scheduledDownloadSubjectDaily": "Su descarga programada diaria",
    "scheduledDownloadSubjectWeekly": "Su descarga programada semanal",
    "scheduledDownloadSubjectMonthly": "Su descarga programada mensual",
    "report": "Informe",
    "reportConfirmSubject": "Por favor, confirme el nuevo informe.",
    "scheduledDownload": "Descarga programada",
    "scheduledDonwloadConfirmSubject": "Por favor, confirme la nueva descarga programada.",
    "scheduledDownloadConfirmMessage": "Si desea mantenerse informado acerca de la siguiente descarga programada, haga clic en el siguiente enlace:",
    "scheduledDownloadUnsubscribe": "Darse de baja de esta descarga programada.",
    "reportConfirmMessage": "Si no desea recibir más correo electrónico sobre este informe, haga clic en el siguiente enlace:",
    "reportUnsubscribe": "No deseo recibir más correo electrónico sobre este informe. ",
    "nameImage": "Imagen",
    "nameFilter": "Filtro",
    "nameDiagram": "Diagrama",
    "nameScheme": "Sistema",
    "maxCustomerImages": "Permite cargar sólo 3 imágenes propias",
    "accepting": {
      "text": {
        "eula": "Aceptar el acuerdo de privacidad y la licencia de usuario final",
        "accept": "Aceptar ahora"
      }
    },
    "downloadFormatTextTabWin": "Texto (tabulado, Windows)",
    "downloadFormatTextSemWin": "Texto (punto y coma, Windows)",
    "downloadFormatTextTabLin": "Texto (tabulado, Linux)",
    "downloadFormatTextSemLin": "Texto (punto y coma, Linux)",
    "downloadFormatVbus": "Datos de protocolo Vbus",
    "nameDownload": "Descargas",
    "nameReport": "Informe",
    "addScheduledDownload": "Añadir nueva descarga programada",
    "enabling": {
      "text": {
        "vbusnet": "Autorizar la visualización con VBus.net",
        "eula": "¡Activando esta opción el usuario acepta que nuestro servicio guarde sus datos conforme al <a href='/eula'>Contrato de licencia de usuario final </a> !"
      }
    },
    "allowParameterizationTextPlain": "Autorizar la configuración con la dirección Via y el RESOL Parameterization Tool (RPT)",
    "settings": "Configuración de la visualización",
    "allowParameterizationText": "Autorizar la configuración con la dirección Via y el <a href='http://www.resol.de/index/software/sprache/en' target='_blank'>RESOL Parameterization Tool (RPT)</a> ",
    "scheduledDownloads": "Descargas programadas",
    "myImage": "Mi imagen",
    "myFilter": "Mi filtro",
    "myScheme": "Mi sistema",
    "myDiagram": "Mi diagrama",
    "myDownload": "Mis descargas",
    "myScheduledDownload": "Mi descarga programada",
    "myReport": "Mi informe",
    "myWeather": "Mi tiempo",
    "downloadButton": "descargar",
    "saveButton": "guardar",
    "showButton": "mostrar",
    "reportsSelectPeriod": "Por favor, elija el periodo de tiempo",
    "extendedReportsInfo": "Reciba nuevos informes que regularmente envían correos electrónicos sobre el estado de su sistema solar. Usted puede recibir información sobre el rendimiento (como un diagrama) o mensajes de error, etc. por ejemplo una vez por semana o una vez al mes. ",
    "extendedReportsWeekInfo": "Si selecciona \"Semanal\", recibirá datos de los <strong>7 últimos días</strong> desde el día seleccionado.",
    "extendedReportsMonthInfo": "Si selecciona \"Mensual\" recibirá los datos del <strong>último mes completo</strong> el primer día de cada mes a la hora deseada.",
    "extendedReportsYearChart": "Resumen anual",
    "extendedReportsWithYearChart": "Con resumen anual",
    "extendedReportsFilterInfo": "Se creará un diagrama para el punto de datos seleccionado. Si lo desea, se creará un resumen anual también.",
    "sendReportAfterSave": "Enviar informe después de guardar.",
    "sendScheduledDownloadAfterSave": "Enviar descarga después de guardar.",
    "sendScheduledDownloadNow": "Enviar la descarga programada ahora",
    "sendReportNow": "Enviar el informe ahora",
    "sendScheduledDownloadNowDialog": "¿Desea activar ahora su descarga programada y recibirla por correo electrónico?",
    "sendReportNowDialog": "¿Desea activar su informe ahora y recibirlo después por correo electrónico?",
    "scheduledDownloadSubjectQuarter": ""
  },
  "monitoring": {
    "weeklyReport": "Su informe semanal",
    "monthlyReport": "Su informe mensual",
    "notificationConnectMail": "Recibirá un e-mail cuando se establezca de nuevo la conexión.",
    "notificationDisconnected": "La conexión al equipo ha sido interrumpida!",
    "notificationStillDisconnected": "La conexión al equipo sigue interrumpida!",
    "notificationDisconnectedNoMail": "No recibirá más e-mails sobre la interrupción de conexión.",
    "notificationConnected": "La conexión al equipo se ha restablecido.",
    "errormaskTrue": "La máscara de error señala un error",
    "errormaskFalse": "La máscara de error no señala ningún error",
    "mailer": {
      "warning": {
        "subject": "Advertencia"
      },
      "error": {
        "subject": "Error"
      },
      "notificationConfirm": {
        "subject": "Por favor confirme la nueva notificación."
      },
      "connection": {
        "subject": "Estado de conexión"
      },
      "notification": {
        "message": "Si desea mantenerse informado acerca de esta notificación, haga clic en el siguiente enlace:",
        "urlText": "Confirme esta dirección de correo electrónico.",
        "unsubscribe": "Darse de baja de esta notificación."
      },
      "userText": "Texto de usuario"
    },
    "thresholdTrue": "Valor límite alcanzado",
    "repealed": "solucionado",
    "notification": "Notificación",
    "statusHasChanged": "El estado de una de las condiciones de la siguiente notificación ha cambiado.",
    "allConditionsAreFulfilled": "Todas las condiciones de la siguiente notificación están cumplidas.",
    "notificationConfirmed": "Su dirección de correo electrónico ha sido confirmada con éxito.",
    "notificationAlreadyConfirmed": "Su dirección de correo electrónico ya ha sido confirmada.",
    "notificationInvalidToken": "Código de confirmación no válido!",
    "timePeriod": "Periodo de tiempo",
    "receiver": "Destinatario",
    "addNewReceiver": "Añadir nuevo destinatario",
    "errorOccurred": "Errores ocurridos",
    "errorEliminated": "Errores eliminados",
    "add": {
      "notification": "Añadir nueva notificación",
      "action": "Añadir nueva acción"
    },
    "notificationConnectionMessage": "La conexión a su equipo será monitorizada automáticamente!<br> Si el equipo no se conecta a VBus.net por más de {1} minutos, usted recibirá un correo electrónico informándole de la interrupción de la conexión. Se le informará acerca de la conexión interrumpida dos veces cada 24 horas respectivamente y usted recibirá un correo electrónico tan pronto se haya restablecido la conexión.",
    "errorLog": "Registro de errores",
    "myNotification": "Mi notificación",
    "conditions": "Condiciones",
    "addNewCondition": "Añadir nueva condición",
    "selectDatapoint": "Seleccione punto de datos",
    "actions": "Acciones",
    "allConditionsFulfilled": "deben cumplirse todas las condiciones",
    "oneConditionFulfilled": "debe cumplirse al menos una condición",
    "message": "Mensaje",
    "hintNotification": "Tiene que añadir al menos una condición y una acción para guardar una notificación.",
    "edit": {
      "notification": "Editar notificación"
    },
    "delete": {
      "notification": "Eliminar notificación?"
    },
    "criterion": "Criterio",
    "delay": "Retraso",
    "trippingTime": "Tiempo de actuación",
    "receivers": "Destinatarios",
    "numberOfConditions": "Número de condiciones",
    "allConditionsFulfilled ": "deben cumplirse todas las condiciones",
    "oneConditionFulfilled ": "debe cumplirse al menos una condición",
    "addNewTemperatureNotification": "Añadir nueva notificación de temperatura",
    "addNewErrorNotification": "Añadir nueva notificación de error",
    "overriding": "Desviación superior",
    "lower deviation": "Desviación inferior",
    "warning": {
      "value": "Valor de advertencia"
    },
    "error": {
      "value": "Valor erróneo"
    },
    "numberOfActions": "Número de acciones",
    "action": "Acción",
    "relatedActions": "Acciones relacionadas",
    "threshold": "Umbral",
    "warningThreshold": "Umbral de advertencia",
    "errorThreshold": "Umbral erróneo",
    "absoluteValue": "Valor absoluto",
    "difference": "Diferencia",
    "minimum": "Mínimo",
    "maximum": "Máximo",
    "greaterOrEqual": "mayor o igual a",
    "lessOrEqual": "inferior o igual a",
    "greaterThan": "mayor que",
    "lessThan": "inferior que",
    "unequal": "desigual",
    "dailyReport": "Su informe diario",
    "reportMessageBodyAttachment": "Su informe está en el archivo adjunto a este correo electrónico.",
    "reportMessageBodyNoAttachment": "Este correo electrónico no contiene informes. Lo más probable es que no hayan datos disponibles para el periodo seleccionado.",
    "currentValue": "Valor actual",
    "condition": "Condición",
    "disconnectionNotification": "",
    "noDisconnectionNotification": ""
  },
  "account": {
    "emailNewConfirmation": "Confirme la nueva dirección de e-mail",
    "changeEmailBodyText": "Ha cambiado su dirección de e-mail. Para confirmar la nueva dirección, haga clic en el enlace de abajo:",
    "activation": {
      "error": "Ha ocurrido un error. Por favor, repita la acción anterior."
    },
    "changeEmailSuccessful": "La nueva dirección de e-mail ha sido confirmada con éxito.",
    "emailNew": "Nueva dirección de e-mail",
    "changeEmail": "Cambiar la dirección e-mail",
    "areYouSure": "¿Está seguro? ",
    "username": "Nombre de usuario",
    "cancel": "Eliminar cuenta",
    "unhappy": "¿No está satisfecho?",
    "deleteMyAccount": "Eliminar mi cuenta",
    "changePassword": "Cambiar la contraseña",
    "create": {
      "user": "Crear una cuenta"
    },
    "edit": {
      "user": "Modificar la cuenta"
    },
    "password": {
      "CurrentPasswordMessage": "Necesitamos su contraseña actual para confirmar las modificaciones realizadas "
    },
    "understoodEulMessage": "He leído y entendido el <a href='/eula'>Contrato de licencia de usuario final</a>.",
    "emailConfimationText": "Le hemos enviado un enlace de confirmación a su dirección e-mail. Haga clic en el enlace para activar su cuenta.",
    "passwordNew": "Nueva contraseña",
    "passwordOld": "Antigua contraseña",
    "passwordNewConfirmation": "Confirmar nueva contraseña",
    "userData": "Datos de usuario",
    "invalid_token": "Ha activado con éxito su cuenta VBus.net. Ahora puede iniciar sesión con sus credenciales de inicio de sesión.",
    "emailOrUsername": "E-mail o nombre de usuario",
    "changeEmailInServices": "Si usted cambia la cuenta de e-mail, esta, será automaticamente cambiada para los siguientes servicios:",
    "changeEmailConfirmation": "Un e-mail de confirmación ha sido enviado a __EMAIL__. Por favor, haga clic en el enlace del correo electrónico para confirmar la nueva dirección.",
    "acceptEulaMessage": "Aceptar condiciones de uso y política de privacidad",
    "AcceptEula": "Para poder seguir utilizando VBus.net deberá aceptar nuestras condiciones de uso y nuestra política de privacidad. "
  },
  "order": {
    "yourOrderSubject": "Su pedido con VBus.net",
    "salesTaxIdentificationNumber": "Número de IVA (CIF/NIF)",
    "positions": "Posiciones",
    "oneYearPro": "1 x acceso a VBus.net PRO (1 año) 39,00 €",
    "bankDetails": "Cuenta Bancaria",
    "paymentDetails": "Debido a la forma de pago deseada mediante transferencia bancaria, le enviaremos inmediatamente la factura por correo electrónico. Por favor use la información de la cuenta bancaria utilizada para la transferencia bancaria indicando el número de factura y la dirección de correo electrónico registrada en VBus.net, para que nosotros podamos asignar y unificar su pago a su pedido.",
    "activatedAfterPayment": "Después de haber recibido su pago, se activará el acceso PRO de VBus.net.",
    "upToThreeDays": "Este proceso puede tardar hasta 3 días.",
    "reference": "Razón de pago",
    "paymentMethod": "Método de pago",
    "order": "Pedido",
    "confirmation": "Usted recibirá una confirmación del pedido por correo electrónico con la información del pago en los próximos minutos. Después de haber recibido su pago, se activará el acceso a VBus.net PRO. ",
    "paymentPaypal": "Pago mediante Paypal",
    "paymentBankTransfer": "Pago mediante transferencia bancaria",
    "paymentPerMail": "Factura por correo electrónico a",
    "now": "Pedir ahora",
    "linkAgb": "Se aplican nuestras Condiciones Generales de Contratación CGC",
    "mustConfirm": "Confirme primero el pedido",
    "VbusVisulizationVor2013": "Encargar el acceso al tool de visualización VBus.net para los DL2 fabricados antes del 2013",
    "withCost": "Encargar aquí",
    "VbusVisulization": "Sí, deseo encargar el acceso al tool de visualización VBus.net",
    "description": "El acceso a la visualización VBus.net se adquiere realizando un pago único de <b>20 euros (IVA incluido)</b>.<br/>Después de realizar el pedido, recibirá un e-mail de confirmación.",
    "umstid": "Número de IVA (CIF/NIF)",
    "billingAdressAdd": "Dirección de facturación, en caso de ser distinta de la dirección personal",
    "dl2": {
      "bevor2012": "Acceso a VBus.net para DL2 anteriores a 2013",
      "thanks": "Gracias por haber elegido VBus.net. Su acceso al equipo está activado. Le deseamos que disfrute de las funciones avanzadas."
    },
    "vatIncluded": "IVA incluido",
    "salutaion": "Estimado",
    "thanksForOrder": "Muchas gracias por su pedido de ",
    "orderDetails": "Detalles de su pedido:",
    "emailReference": "Para pago por transferencia bancaria, por favor indique su dirección de correo electrónico VBus.net como la razón de pago, para que nosotros podamos asignar su pago a su pedido y cuenta.",
    "sendOrder": "Enviar el pedido",
    "accountUpdated": "",
    "currentSubscription": "",
    "newSubscription": "",
    "validUntil": "válida hasta"
  },
  "professional": {
    "willExpire": "Su acceso VBus.net PRO vencerá en {1} días.",
    "order": {
      "euvat": {
        "explanation": "Por la presente confirmo que mi residencia principal está en el mencionado país. Esto sirve como base para el cálculo del IVA (compradores solo dentro de la UE)."
      },
      "information": {
        "required": "Información necesaria"
      },
      "require": {
        "text": "El vendedor de este artículo requiere la siguiente información:"
      },
      "received": "Hemos recibido su pago con PayPal",
      "thanks": "Gracias por elegir VBus.net PRO. Su acceso VBus.net PRO está activado. Esperemos que usted disfrute de las funciones avanzadas.",
      "redirect": {
        "wait": "Su pedido se envía ahora a PayPal.",
        "wait2": "Esto puede tardar varios segundos."
      }
    },
    "own": {
      "scheme": {
        "images": "Personalización de imágenes del sistema"
      }
    },
    "data": {
      "live": {
        "time": "Almacenamiento de datos"
      }
    },
    "function": {
      "overview": "Resumen de accesos VBus.net"
    },
    "time": {
      "live": {
        "data": "Actualización de datos"
      }
    },
    "enhanced": {
      "scheme": {
        "editor": "Editor avanzado de sistema"
      }
    },
    "dl2": {
      "inclusive": "Acceso a VBus.net, también para DL2 anteriores a 2013"
    },
    "error": {
      "protocol": "Protocolos de error"
    },
    "monitoring": "Notificaciones",
    "friendship": {
      "function": "Compartir equipo"
    },
    "subscription": {
      "name": {
        "basic": "Básico",
        "professional": "PRO"
      }
    },
    "subscriptionRequired": "Es necesario el acceso VBus.net PRO para esta acción.",
    "expired": "EXPIRADO",
    "extendOneYear": "Prorrogar durante un año (con coste)."
  },
  "extend": {
    "professional": {
      "account": "Prorrogar ahora su acceso PRO."
    }
  },
  "address": {
    "herr": "Señor",
    "frau": "Señora",
    "billingAddress": "Dirección de facturación",
    "firma": "Empresa",
    "anrede": "Título",
    "vorname": "Nombre",
    "nachname": "Apellido",
    "strasse1": "Calle 1",
    "strasse2": "Calle 2 ",
    "postleitzahl": "Código postal",
    "ort": "Ciudad",
    "plz": "CP",
    "land": "País",
    "businessCustomer": "Cliente empresa",
    "privateCustomer": "Cliente particular",
    "email": "E-mail",
    "telefon": "Teléfono",
    "fax": "Fax",
    "internet": "Internet",
    "strasse": "Calle ",
    "bundesland": "Provincia",
    "kundennummer": "Número de cliente",
    "webseite": "Página web",
    "name": {
      "first": "Nombre",
      "last": "Apellido(s)"
    },
    "address": "Dirección",
    "kunde": "Cliente"
  },
  "backbone": {
    "validation": {
      "required": "es necesario",
      "email": "debe ser una dirección de correo electrónico válida",
      "acceptance": "debe ser aceptado",
      "min": "debe ser mayor o igual a {1}",
      "max": "debe ser menor o igual a {1}",
      "range": "debe estar entre {1} y {2}",
      "length": "debe ser {1} caracteres",
      "minLength": "debe ser por lo menos {1} caracteres",
      "maxLength": "debe ser a lo sumo {1} caracteres",
      "rangeLength": "debe estar entre {1} y {2} caracteres ",
      "oneOf": "debe contener: {1}",
      "equalTo": "debe ser lo mismo que {1}",
      "digits": "debe contener sólo dígitos",
      "number": "debe ser número",
      "url": "debe ser una dirección URL válida",
      "inlinePattern": "no es válido",
      "matchPasswords": "las contraseñas no son idénticas",
      "matchEmail": "Las direcciones de e-mail no son identicas.",
      "compareWithOriginalEmail": "La nueva dirección de e-mail no debe ser idéntica a la actual dirección."
    }
  },
  "errors": {
    "messages": {
      "already_confirmed": "ya fue confirmada, por favor intente iniciar sesión",
      "prohibited": {
        "ownership": {
          "one": "1 error prevented this device ownership from being saved:",
          "others": "2 errors prevented this device ownership from being saved:"
        }
      }
    }
  },
  "passwordWrong": "La contraseña actual es incorrecta. ¡Por favor, compruebe la entrada!",
  "ownership": {
    "invalidToken": "Código de acceso (token) no válido.",
    "alreadyClaimed": "Este equipo ya ha sido añadido.",
    "successfully": {
      "created": "Este equipo ha sido actualizado con éxito.",
      "deleted": "El equipo ha sido eliminado con éxito!"
    },
    "alreadyInOwnAccount": "Este dispositivo estaba disponible en su cuenta. Si desea restaurar, por favor, seleccione de la lista. <br>Si desea agregar el dispositivo como un nuevo dispositivo, los datos anteriores no se restaurarán.",
    "alreadyInOtherAccount": "¡Este dispositivo ya ha sido añadido a una cuenta! <br>El dispositivo tiene que ser eliminado o, si está en su posesión, retroceda. <br>Por favor preste atención a las notas en el manual.",
    "restoreThisDevice": "Restaurar este dispositivo",
    "deleteOwnership": "Eliminar este equipo",
    "addAsNew": "Añadir nuevo dispositivo",
    "confirmText": "¿Está seguro de querer eliminar este equipo?",
    "claim": {
      "online": {
        "message": "Para poder añadir un equipo, su datalogger o módulo de comunicación KM1 debe estar conectado a Internet."
      }
    },
    "via_tag": "Etiqueta vía",
    "editing": "Editar equipo",
    "description": {
      "via_tag": "Introduzca una etiqueta vía y guárdela para poder personalizar su dirección Via. Después de guardar la etiqueta vía, podrá utilizar la dirección vía para acceder a los datos de su sistema en Internet.<br/>La etiqueta vía debe incluir por lo menos 3 carácteres y empezar con minúscula. Se admiten los siguientes carácteres: minúsculas, números y guiones."
    },
    "claimedSuccessful": "Su __PRODUCT-NAME__ se ha añadido correctamente.",
    "getFirstDataHeader": "Consulta de datos en curso...",
    "getFirstDataSubtext": "Conexión establecida. Este proceso puede tardar varios minutos...",
    "dataReceivedSuccessfully": "Consulta de datos exitosa ",
    "initSettingsText": "Por favor inserte la siguiente información en su equipo: ",
    "claimOwnFriendshipToken": "",
    "adjustTimestamps": "",
    "adjustTimestampsInfo": "",
    "openSettings": ""
  },
  "viatag": {
    "alreadyInUse": "Esta etiqueta vía ya está en uso"
  },
  "demo": {
    "temperature": {
      "collector": "Temperatura del captador",
      "storage": {
        "below": "Temperatura del acumulador (parte inferior)",
        "above": "Temperatura del acumulador (parte superior)"
      }
    },
    "pump": {
      "speed": "Velocidad de bomba solar"
    },
    "valve": {
      "storage": "Válvula de acumulador"
    },
    "maximum": {
      "count": {
        "exeed": "El datalogger de muestra no ha podido ser habilitado. Cada usuario es capaz de añadir sólo un datalogger de muestra!"
      }
    }
  },
  "error": {
    "messages": {
      "not_found": "No se encontró"
    },
    "noData": {
      "aviable": "No existen datos para los ajustes seleccionados."
    },
    "tooManyRequests": ""
  },
  "coupon": {
    "claimedSuccessful": "Su cupón ha sido canjeado con éxito. Su acceso PRO ahora ha sido activado / extendido por:",
    "alreadyClaimed": "Este cupón ya ha sido usado",
    "invalidToken": "Código de cupón inválido",
    "youHaveACoupon": "Tiene un cupón?",
    "code": "Código de cupón",
    "redeemCoupon": "Canjear cupón",
    "name": "Cupón",
    "enterCouponCode": "Inserte su código de cupón aqui ",
    "redeemAnotherCoupon": "Canjear otro cupón",
    "deviceWithTestPro": "Su nuevo equipo tiene un cupón - pruebe VBus.net PRO durante 30 días sin cargo",
    "redeemNow": "Canjear cupón ahora",
    "redeemLater": "Canjear cupón luego",
    "redeemLaterText": "También puede canjear el cupón más adelante - el código es: __COUPON__ (se puede también encontrar en la contraportada del manual)."
  },
  "device": {
    "notFound": "Equipo no encontrado.",
    "newFirmwareAvailable": "Una nueva versión de firmware __VERSION__ está disponible!",
    "serial": "Serie",
    "version": "Versión",
    "build": "Fabricado",
    "product": "Producto",
    "fw_feed": "Fw feed",
    "firmware_feed": "Firmware feed",
    "newFirmware": "Nuevo firmware disponible",
    "claimInfoPorts": "¡Tenga en cuenta que su datalogger (DL2/DL3) o módulo de comunicación (KM2) debe estar conectado a Internet y debe tener acceso a VBus.net! Para que el datalogger o el módulo de comunicación pueda acceder a VBus.net, el acceso a los puertos 80 y 1194/1195 deberá ser posible sin restricciones.",
    "claimInfoLed": "El LED de control de funcionamiento debe estar permanentemente encendido en verde",
    "claimVbusActivated": "VBus.net debe estar activado",
    "claimInfoNetwork": "debe aparecer en el menú Red",
    "claimInfoNoVisualizationSettings": "No existe ninguna configuración de visualización para este aparato."
  },
  "dataProtection": {
    "Einwilligung": "Consentimiento en virtud de la ley de protección de datos",
    "EinwilligungWiderruf": "Puede revocar su consentimiento en cualquier momento enviando un <span class=\"nobr\">correo electrónico</span> a datenschutz@dvm-cloud.net.",
    "EinwilligungText1": "Entiendo y acepto las URL_NUTZUNG y las URL_DATENSCHUTZ."
  },
  "eula": {
    "acceptWarning": "Tiene que aceptar la licencia de usuario final y el acuerdo de privacidad para poder continuar.",
    "agb": "Condiciones de uso ",
    "privacyPolicy": "Política de privacidad",
    "reaccept": "Hemos cambiado nuestra licencia de usuario final y privacidad. Tiene que aceptar para continuar.",
    "name": "Acuerdo de privacidad y licencia de usuario final",
    "acceptText": "Haciendo clic en el signo arriba, usted acepta con nuestro __eula__."
  },
  "filter": {
    "add": "Añadir nuevo filtro ",
    "showAll": "Visualizar todas",
    "edit": "Modificar filtro",
    "name": "Nombre del filtro",
    "addToFilter": "Añadir al filtro",
    "show": "Visualizar",
    "mustBeAString": "Debe ser un texto",
    "atLeastOneDatapoint": "Tiene que añadir al menos un campo de datos para el filtro!",
    "showUsed": "Editar solo la configuración predeterminada",
    "pleaseSelectDatapoints": "Por favor, seleccione los puntos de datos de la lista de sus datos en tiempo real.",
    "noFilterData": "¡No hay datos de filtro disponibles!",
    "changedLiveData": "¡Sus datos en tiempo real han cambiado desde que se creó el filtro!",
    "noConversionAvailable": "No hay ninguna conversión disponible",
    "conversionError": "¡Error en la conversión!",
    "changedLiveDataShowOldValues": "",
    "maxValues": "",
    "datapointNotEditable": ""
  },
  "day": {
    "today": "Hoy ",
    "yesterday": "Ayer",
    "lastTwo": "Últimos 2 días",
    "lastSeven": "Últimos 7 días",
    "lastThirty": "Últimos 30 días",
    "currentMonth": "Mes actual",
    "lastMonth": "El mes pasado",
    "sa": "Sab",
    "So": "Dom",
    "do": "Juev",
    "Di": "Mar",
    "Mi": "Mier"
  },
  "ademe": {
    "module": "Módulo",
    "filter": {
      "header": "Filtro con módulos",
      "units": "Filtro con unidades",
      "allModules": "Todos los módulos",
      "allUnits": "Todas las unidades"
    },
    "report": {
      "add": "Crear nuevo informe",
      "edit": "Editar informe",
      "save": "Guardar Informe"
    },
    "add": {
      "header": "ADEME:"
    },
    "systemType": "Tipo de sistema",
    "systemNumber": "Nº de sistema",
    "value": "Valor",
    "values": "Valores",
    "error": {
      "systemNumberStart": "El número de sistema debe empezar con IS!",
      "systemNumberLength": "El número de sistema debe tener entre 12 y 14 caracteres!",
      "systemNumberCharacter": "El número de sistema contiene caracteres no válidos!",
      "systemNumberYear": "El número de sistema no contiene un año válido!",
      "SystemType": "<br />Por favor seleccione un tipo de sistema!"
    },
    "hint": {
      "successSaveHeader": "Exitoso!",
      "successSaveBody": "Sus datos se han guardado con éxito!",
      "warningSaveHeader": "¡ADVERTENCIA!",
      "warningSaveBody": "Ya ha guardado datos! Los cambios pueden tener un efecto sobre su financiación de ADEME."
    },
    "select": {
      "systemType": "Seleccionar un tipo de sistema"
    },
    "system": "Sistema",
    "units": {
      "Energy": "Energía",
      "Temperature": "Temperatura",
      "CubicMeter": "Metro cúbico"
    }
  },
  "sideBar": {
    "filters": "Filtro",
    "images": "Imágenes",
    "liveSchemes": "Sistemas a tiempo real",
    "diagrams": "Diagramas",
    "downloads": "Descargas",
    "reports": "Informes",
    "notifications": "Notificaciones",
    "visualization": "Visualización",
    "friends": "Compartir equipo",
    "dashboard": "Panel de control",
    "parametrization": "Parametrización WebRPT ",
    "discovery": "DeviceDiscoveryTool",
    "utilities": "Herramientas",
    "myVBusNet": "Mi VBus.net",
    "status": "Estado",
    "ademe": "ADEME",
    "monitoring": "Monitorización"
  },
  "choose": {
    "download": {
      "format": "Por favor, elija un formato de descarga"
    },
    "system": "Por favor, elija un sistema",
    "background": {
      "image": "Por favor, elija una imagen de fondo"
    },
    "filter": "Por favor, elija una selección de datos",
    "periodOfTime": "Por favor, elija un período de tiempo",
    "image": "Seleccione una imagen",
    "device": "Seleccionar aparato"
  },
  "plan": {
    "valid": {
      "until": "Válida hasta"
    },
    "order": {
      "here": "Encargar aquí"
    },
    "days": {
      "left": "Días restantes"
    },
    "trial": {
      "expired": "EL PERÍODO DE PRUEBA HA EXPIRADO"
    }
  },
  "subtitle": {
    "myDevices": "Mis equipos",
    "myVirtualDevices": ""
  },
  "unit": {
    "add": "+ Sumar el valor",
    "sub": "- Restar el valor",
    "mul": "* Multiplicar el valor",
    "div": "/ Dividir el valor",
    "inv": "1/ Valor (Valor recíproco)",
    "calculate": "Convertir unidad"
  },
  "parameterization": {
    "supportedDevicesText": "Actualmente se pueden parametrizar los siguientes aparatos a través de VBus.net:",
    "rptWebseite": "Si su aparato aún no es compatible con VBus.net, puede utilizar alternativamente nuestra herramienta de parametrización RESOL RPT. Puede encontrar más información sobre RPT en nuestra página web:",
    "connectionRptServer": "Estableciendo la conexión con el servidor WebRPT...",
    "connectionRptServerError": "¡No se pudo establecer ninguna conexión con el servidor WebRPT!",
    "connectionRptServerRetry": "Compruebe de nuevo la conexión...",
    "checkConncectionToDevice": "Comprobar parametrizabilidad",
    "notParameterizable": "No parametrizable",
    "vbusPassword": "Contraseña VBus",
    "passwordHint": "Introducir la contraseña para el mantenimiento a distancia (ajuste de fábrica: vbus).",
    "loadConfig": "Cargar configuraciones guardadas:",
    "pleaseEnterVbusPassword": "Introduzca la contraseña de VBus y haga clic en SIGUIENTE…",
    "dataTransmission": "Transferencia de datos en curso…",
    "configurationNotLoadable": "¡La configuración no se puede cargar!",
    "deleteConfiguration": "¿Desea borrar esta configuración?",
    "errorTimeout": "Tiempo de espera para la conexión con el datalogger / módulo de comunicación",
    "errorConnection": "El datalogger / módulo de comunicación no está conectado a VBus.net",
    "errorNetwork": "Por favor, compruebe su cableado de red y/o datalogger / módulo de comunicación",
    "wrongVbusPassword": "¡Contraseña VBus incorrecta!",
    "errorNoResponse": "¡El regulador no responde!",
    "errorVbus": "Por favor, compruebe el cable VBus y/o el regulador.",
    "errorCode": "Código de error",
    "errorLogin": "¡La sesión WebRPT ha expirado!",
    "login": "¡Por favor, identifíquese de nuevo!",
    "notParametrizable": " No se puede parametrizar.",
    "changedController": "¡El regulador ha cambiado!",
    "withoutConfiguration": "Empezar sin configuración",
    "brokenConfiguration": "Configuración defectuosa",
    "proRequired": "¡Se requiere acceso PRO!",
    "rpt": "Nota de RPT",
    "start": "Parametrizar ahora",
    "connectionController": "Estableciendo conexión con el regulador...",
    "noConnectionVBusnet": "¡No se ha podido establecer la conexión con VBus.net!",
    "checkStep1": "Compruebe su DL2/DL3/KM2 y, dado el caso, los ajustes de red de estos, así como los ajustes que usted tenga de Internet y del cortafuegos.",
    "noConnectionController": "¡No se ha podido establecer la conexión con el regulador!",
    "checkStep2": "Compruebe si el regulador está listo y si el cable de VBus está conectado correctamente.",
    "wrongPassword": "¡Contraseña no válida para VBus!",
    "checkStep3": "Compruebe los datos introducidos y luego haga clic en SIGUIENTE.",
    "controllerNotParameterizable": "¡Regulador no parametrizable!",
    "checkStep4": "Compruebe si su regulador admite la parametrización.",
    "connectionVbusnet": "Conexión a VBus.net",
    "controller": "Regulador",
    "checkVersion": "Comprobación de versión",
    "configurable": "¿Parametrizable?",
    "getSupportedDevices": "Buscando aparatos compatibles...",
    "foundSupportedDevices": "Se han encontrado los siguientes aparatos, que pueden ser parametrizados dependiendo de la versión del software:",
    "noSupportedDevices": "¡No se han encontrado aparatos compatibles!",
    "configuration": "Configuración",
    "notAllowed": ""
  },
  "parametrization": {
    "header": "Software de configuración remota RPT",
    "supportedDevices": "Los siguientes modelos RESOL son compatibles:",
    "subHeader": "Software para parametrizar reguladores RESOL",
    "downloadFree": "Descargar el software RPT gratuitamente",
    "rptSoftware": "Software RPT (Versión 1.9)",
    "licenseNote": "Licencia",
    "manualPdf": "Manual (PDF)",
    "systemRequirements": "Requisitos del sistema operativo: Windows 7, ien modo de compatibilidad con: Windows 8.1 / 10, 32 bit Java desde la versión 1.6",
    "howToStepOne": "Ejecute el software RPT software en su PC, después seleccione <strong>Conectar...</strong> en el menú <strong> Comunicación</strong>.",
    "howToStepTwo": "Seleccione un equipo en uso y luego entre la etiqueta via en el campo <strong>Dirección URL/ IP</strong>.",
    "howToStepThree": "Puede encontrar la etiqueta vía en el siguiente menú:",
    "howToStepFour": "Inserte su contraseña. Si no la ha cambiado, esta es <strong>vbus</strong>.",
    "howToStepFive": "Haga click en <strong>Conectar</strong>. Puede parametrizar su regulador ahora.",
    "deviceNotListed": "Si su regulador no esta en la lista, por favor, utilice",
    "rscSoftware": "RESOL Service Center Software RSC",
    "requiredDevices": "Para poder utilizar el softaware de parametrización de RPT, necesita los siguientes dispositivos RESOL:",
    "youNeedDevice": "¿Todavía no tiene un dispositivo RESOL? Haga click <a href=\"http://www.resol.com/\" target=\"_blank\"> aquí</a> para visitar nuestra página Web."
  },
  "settingsDocumentation": {
    "errorTryAgain": "Por favor Inténtalo más tarde. Si el problema persiste, póngase en contacto con el equipo de soporte técnico RESOL: support@resol.de",
    "description": "El generador de documentación de configuración crea una documentación (PDF) desde su archivo SET.",
    "selectSetFile": "Seleccione el archivo SET",
    "documentTitle": "Título del documento",
    "convertSetFile": "Convertir archivo SET",
    "startConversion": "Empezar la conversión",
    "downloadPdfFile": "Descargar el archivo en PDF",
    "settingsDocumentationGenerator": "Generador de documentación de configuración",
    "optionalTitel": "Título opcional",
    "invalidSetFile": "Formato de archivo SET no válido",
    "incompatibleSetFile": "El archivo proporcionado no es un archivo SET compatible con una RESOL DeltaSol MX 2.xx. Por favor, pruebe con un archivo diferente.",
    "convertionFailed": "Conversión fallida",
    "errorConversionTookToLong": "Tardó demasiado tiempo para completar la conversión.",
    "converting": "Convirtiendo",
    "errorAllowedCharacters": "Sólo letras, números, guiones (-), espacios ( ) y guiones bajos (_) están permitidos en el título.",
    "pdfFile": "Archivo PDF"
  },
  "passwordSame": "¡La nueva contraseña es idéntica a la contraseña actual!",
  "delete": {
    "entry": {
      "text": "Esta entrada de datos no se puede borrar porque está siendo usada en las siguientes funciones:",
      "header": "Borrar entrada",
      "question": "¿Desea realmente borrar la entrada <span id='myModalName' class='delete_question'></span> ?"
    }
  },
  "unitFamily": {
    "temperature": "Temperatura",
    "volume": "Caudal",
    "pressure": "Presión",
    "power": "Potencia",
    "energy": "Energía",
    "volumeFlow": "Caudal",
    "time": "Hora"
  },
  "deleteAccount": "¡Todos sus datos y su acceso a VBus.net serán borrados irrevocablemente! ¡Este proceso no se puede deshacer! Por favor, introduzca su contraseña actual para confirmar.",
  "passwordRequired": "¡Por favor, introduzca su contraseña actual!",
  "yesDeleteAccount": "Sí, borrar todos los datos",
  "topBar": {
    "editProfile": "Mi perfil",
    "registerHere": "Regístrese ahora gratis",
    "imprint": "Aviso legal",
    "register": "Registrarse",
    "home": "Página de inicio"
  },
  "passwordHackInfo": "¡Los especialistas en TI necesitan <b>TIME</b>, para calcular esta contraseña!",
  "changePasswort": {
    "noToken": "¡No se encontró ningún token válido para resetear la contraseña! Tenga en cuenta que el token de reset solo es válido durante 1 día. Si es necesario, solicite de nuevo el enlace de reset de la contraseña."
  },
  "twoFactorTokenAlredyExists": "Los códigos de recuperación solo se pueden crear una vez.",
  "dataviewer": {
    "title": "Para visualizar los datos del sistema a través de tarjeta de memoria SD. Los datos se mostrarán en una tabla de progreso ordenada. Tampoco necesita un Datalogger ni un módulo de comunicación. El controlador no tiene que estar conectado a Internet. Los datos permanecerán guardados - las visualizaciones no se guardarán."
  },
  "diagram": {
    "add": "Añadir nuevo diagrama",
    "allow": {
      "public": "Crear un enlace de visualización para el diagrama"
    },
    "edit": "Modificar diagrama",
    "data": "Datos",
    "height": "Altura",
    "width": "Ancho",
    "noDataSelected": "No hay datos seleccionados.",
    "min": "Min.",
    "max": "Máx.",
    "publicUrlCustomRangeWarning": "La opción <strong>Período elegido por usuario </strong> no está disponible para los diagramas publicos."
  },
  "vbus": {
    "deactivateFilter": "El archivo del protocolo VBus contiene todos los valores. La función Filtro se desactiva. ",
    "net": "VBus.net"
  },
  "download": {
    "add": "Añadir nueva descarga",
    "edit": "Modificar descarga",
    "noDataForSelectedPeriod": "¡No hay datos para el período seleccionado!",
    "forOtherOs": ""
  },
  "tooltip": {
    "filter": {
      "standardvorgabe": "Puede guardar cada filtro como estándar predeterminado y utilizarlo como plantilla para nuevos filtros. Puede crear un estándar predeterminado para cada aparato."
    }
  },
  "default": {
    "filter": {
      "load": {
        "msg": "Cargar estándar predeterminado",
        "text": "Utilice este filtro como el predeterminado"
      },
      "values": "Configuración predeterminada del filtro",
      "exists": {
        "text": "Ya ha creado un filtro para este dispositivo."
      },
      "default": {
        "text": "¿Te gustaría usar este filtro como configuración predeterminada?.",
        "create": "Crear una configuración predeterminada para este sistema",
        "load1": "Añadir configuración predeterminada a la lista",
        "load2": "Modificar la lista con la configuración predeterminada",
        "load3": "Modificar la lista con la configuración predeterminada y agregar valores"
      }
    },
    "load": "Cargar",
    "default": {
      "notexists": {
        "text": "No ha proporcionado todavía un valor predeterminado para este dispositivo.",
        "text1": "Quiere proporcionar un valor predeterminado ahora?"
      },
      "create": {
        "text": "Crear un valor predeterminado"
      }
    }
  },
  "heating": {
    "systems": "Sistemas de calefacción"
  },
  "solar": {
    "systems": "Sistemas solares",
    "collectors": "Captadores",
    "storages": "Acumuladores",
    "collector": "Captador",
    "system": "Sistema solar"
  },
  "image": {
    "add": "Añadir nueva imagen ",
    "name": "Nombre de la imagen",
    "validMimeType": "La imagen debe tener el formato .jpg, .jpeg, .png o .gif",
    "edit": "Modificar imagen",
    "maxFilesize": "Tamaño máximo del archivo",
    "delete": "¿Desea realmente borrar la imagen?"
  },
  "scheme": {
    "allow": {
      "public": "Crear un enlace de visualización para  el sistema"
    },
    "setDatapoints": "Posicionar los datos",
    "add": "Añadir nuevo sistema",
    "edit": "Modificar sistema",
    "publicUrl": "Por medio de un enlace público, tiene acceso a su sistema a tiempo real, incluso si no se está registrado en VBus.net. Puede compartir este enlace con personas que no estén adscritas en VBus.net. También puede añadir este enlace a su propia página Web con el fin de mostrar su sistema a tiempo real."
  },
  "reports": {
    "dotDayOfMonth": "día del mes",
    "dotDay": ".día de cada",
    "dotMonth": ".mes a las"
  },
  "please": {
    "wait": "Por favor, espere…"
  },
  "parameterizationsettings": {
    "translation": "Ajustes de la configuración",
    "makeShureNotDefaultPasswordText": "Por favor, asegúrese de que la contraseña que permite configurar el regulador a través de la intefaz web del datalogger no sea la contraseña por defecto 'vbus' .",
    "changePasswordText": "Para cambiar dicha contraseña, haga clic en el siguiente enlace:"
  },
  "claim": {
    "howToFindToken": "Cómo encontrar su código de acceso"
  },
  "index": {
    "claimANewDevice": "Añadir un equipo",
    "editThisInformation": "Modificar esta información",
    "welcomeToVBusnet": "¡Bienvenidos a VBus.net!",
    "youNotHaveADataloggerYet": "No tiene ningún equipo? Haga clic aquí para añadir un datalogger de muestra a su cuenta…",
    "noVideo": "No se ve el vídeo? Utilice las siguientes alternativas",
    "videoDownload": "Descargar el vídeo",
    "orOn": "o en",
    "ifYouDoNotHaveADataloggerYet": "Si desea probar VBus.net sin tener un equipo, añada un datalogger de muestra a su cuenta realizando las siguientes operaciones:",
    "list": {
      "logInToVBusNet": "Inicie la sesión en VBus.net",
      "addADemonstationLogger": "Añada un datalogger de muestra a su cuenta ",
      "activateOptionDatalogger": "Active la opción correspondiente en el datalogger",
      "getActivationToken": "Anote el código de acceso",
      "claimLoggerWhithToken": "Introduzca el código de acceso para añadir un equipo."
    },
    "download": {
      "datasheet": "Descargue aquí la<br />hoja de datos de VBus.net !",
      "manual": "Descargue aquí las<br />instrucciones de VBus.net !"
    },
    "text1": "VBus.net es una plataforma de servicios web de <a href=“http://www.resol.com“>RESOL</a> que le permite acceder a su equipo RESOL en pocos clics, esté donde esté.",
    "text3": "VBus.net utiliza y trata los datos de su regulador RESOL. Para tener acceso a esos datos, debe añadir su equipo a su cuenta realizando las cuatro etapas siguientes:",
    "noVideoPlaybackText": "Su explorador de Internet no le permite ver el vídeo<SEMICOLON>, descargue el siguiente vídeo.",
    "general": {
      "register": "Pruébelo gratis ahora sin compromiso"
    },
    "howto": {
      "question": "¿Quiere saber cómo funciona?"
    },
    "customer": {
      "examples": "¿Quiere ver cómo nuestros clientes utilizan VBus.net?"
    },
    "title": "Visualice sus datos del sistema",
    "text2": "Visualice el progreso de temperatura, confeccione sistemas personalizados a tiempo real  y diagramas de forma gratuita.",
    "liveSystemExample": "",
    "createNewVirtualDevice": ""
  },
  "show": {
    "liveData": "Visualizar datos a tiempo real"
  },
  "friendship": {
    "createToken": "Crear nuevo código de acceso (token)",
    "createdFriendships": "Códigos de acceso creados",
    "createAccessTokenText": "<b>Comparta sus datos con otros usuarios de VBus.net</b><br/><br>Cree un nuevo código de acceso (token) para los usuarios de VBus.net con el fin de garantizarles acceso a sus datos. Por lo tanto, estos usuarios pueden crear sus propios diagramas y sistemas a tiempo real que utilizan los datos del sistema. <br/><br/>Los usuarios pueden añadir este código de acceso como un nuevo equipo en su cuenta de VBus.net <b>mis equipos <i class=\"fa fa-angle-right\"></i> Añadir un equipo</b>. Comunique el código de acceso. <br/><br/> Por supuesto, usted siempre puede retirar su acceso.",
    "featureNotAvailable": ""
  },
  "feedbackForm": {
    "thankYou": "Muchas gracias por su respuesta.",
    "yourOpinion": "Su opinión es importante para nosotros!",
    "helpText": "Desea participar en la mejora de VBus.net o quiere comunicarnos sus ideas, deseos o propuestas? Utilice nuestro formulario de feedback.",
    "assessmentText": "Por favor, evalúe lo siguiente:",
    "scopeOfFunctions": "Funcionalidad",
    "userFriendliness": "Facilidad de uso",
    "use": "Utilidad",
    "response": "Sus comentarios serán procesados bajo el número _ID_.",
    "yourSatisfaction": "Su satisfacción"
  },
  "imprint": {
    "chief": "Representante legal de la compañia",
    "court": "Registro mercantil",
    "registration": {
      "number": "Número de identificación fiscal "
    },
    "vat": "Número de Identificación Fiscal a efectos del IVA conforme al párrafo § 27a de la Ley del Impuesto al Valor Agregado",
    "poweredBy": "Powered by",
    "technic": {
      "design": "Internet Técnica & Diseño"
    }
  },
  "sales": {
    "tax": {
      "act": "(Umsatzsteuergesetz en alemán)"
    }
  },
  "howto": {
    "vbusdotnet": "VBus.net permite visualizar datos de su sistema a tiempo real. También ofrece la posibilidad de crear diagramas de los valores grabados durante un determinado período de tiempo y descargarlos.",
    "storageDuration": "Sus datos se almacenan durante 90días (Básico) o 1 año (PRO).",
    "liveData": "Visualice los datos de su sistema de energía solar a tiempo real.",
    "filter": "Cree selecciones de datos para utilizarlas en sus descargas, sistemas a tiempo real y diagramas. Cambie los nombres por defecto de los datos y elija un color para la línea de los diagramas.",
    "images": "Guarde las imágenes de los esquemas de su sistema de energía solar para reutilizarlas posteriormente. Elija una de las imágenes por defecto o cargue su propia imagen.",
    "downloads": "Descargue los datos grabados de su sistema de energía solar en varios formatos durante un determinado período. Guarde las descargas para reutilizarlas posteriormente o realice una descarga rápida para usarla de inmediato. Para ello, puede limitar la cantidad de datos mediante un filtro previamente definido (vea más arriba).",
    "liveSchemes": "Visualice sus datos en directo en un esquema de su sistema de energía solar. Posicione los datos (nombre y valor) arrastrándolos simplemente en el lugar deseado en la imagen de la derecha. La posición se guarda automáticamente. Para ello, sólo es necesario un filtro y una imagen previamente definidos (vea más arriba)",
    "diagrams": "Visualice sus datos grabados en un diagrama durante un determinado período. Para ello, necesita un filtro previamente definido (vea más arriba).",
    "question": "¿Cómo funciona?",
    "friends": "Comparta su equipo con otros usuarios de VBus.net, con el fin de otorgarles acceso a su sistema. Por lo tanto, los usuarios con los que comparte su equipo podrán crear sus propios diagramas, sistemas a tiempo real, etc..",
    "monitoringGeneral": "Con la monitorización VBus.net tendrá acceso al protocolo de error en el que se listarán errores automáticamente. También tendrá acceso a las notificaciones, mediante las cuales, usted puede monitorizar los diferentes parámetros de sistema y ser informado por correo electrónico.",
    "monitoringNotification": "Con las notificaciones usted puede seleccionar y monitorizar diferentes parámetros de sistemas, tales como temperatura, cantidad de calor o máscaras de error. Puede determinar umbrales y compararlos con los datos de los sistemas a tiempo real por medio de diferentes criterios. Si se cumplen las condiciones de una notificación, y si están definidos otros destinatarios serán informados vía correo electrónico. En el caso de una interrupción de la conexión, automáticamente recibirá una notificación por correo electrónico. También se le informará si la conexión se ha re-establecido.",
    "monitoringErrorlog": "El protocolo de error da una descripción de los errores que se han producido en su sistema. El protocolo proporciona información sobre fecha y hora de errores y, si es compatible con el regulador, indica el módulo correspondiente y el sensor. Esto puede utilizarse, por ejemplo, para solucionar problemas.",
    "reports": "Reciba los datos del sistema con regularidad y automáticamente vía correo electrónico. Puede definir un período de tiempo y limitar el número de puntos de datos con un filtro definido anteriormente (ver arriba). También puede agregar más destinatarios a las descargas programadas.",
    "backup": "Crear una copia de seguridad de todos los ajustes de visualización.",
    "extendedReports": "Reciba nuevos informes que regularmente envían correos electrónicos sobre el estado de su sistema solar. Usted puede recibir información sobre el rendimiento (como un diagrama) o mensajes de error, etc. por ejemplo una vez por semana o una vez al mes. ",
    "conversionsAndArithmeticOperations": "Conversiones y cálculos de puntos de datos",
    "parametrization": ""
  },
  "links": {
    "didNotReceiveConfirmationInstructions": "¿No ha recibido la confirmación de su inscripción?",
    "didNotReceiveUnlockInstructions": "¿No ha recibido instrucciones par desbloquear su cuenta?"
  },
  "customer": {
    "examples": "Ejemplos de clientes"
  },
  "dashboard": {
    "proSubscriptionSchemeEditor": "Editor avanzado de sistema",
    "testProSubscription": "Pruebe VBus.net PRO durante 30 días gratuitamente!",
    "proSubscriptionLiveData": "Actualización de datos cada minuto",
    "proSubscriptionWeatherDashboard": "Información meteorológica para su ubicación en el panel de control",
    "proSubscriptionErrorLog": "Protocolo de notificaciones de error de su sistema",
    "proSubscriptionReporting": "Notificaciones por correo electrónico configurables ",
    "proSubscriptionFriendship": "Compartir los derechos de acceso, por ejemplo, con su instalador para fines de información y servicio",
    "proSubscriptionEnable": "Sí, me gustaría probar el acceso PRO",
    "proSubscriptionDoNotRemember": "No, no me lo recuerde",
    "textClaimDemoQuestion": "¿Todavía no tiene un Datalogger o un módulo comunicación?",
    "textClaimDemo1": "Sin embargo, ¿desea aprender más sobre las posibilidades de VBus.net?",
    "textClaimDemo2": "Luego agregue un datalogger de demo a su cuenta.",
    "claimDemo": "Añadir un datalogger de demo ahora",
    "textClaimOwnQuestion": "¿Ya tiene un Datalogger o un módulo de comunicación?",
    "textClaimOwn1": "Añada su propio equipo a su cuenta.",
    "claimOwn": "Añadir un nuevo equipo ahora",
    "noDiagramAvailable": "Tiene que crear, al menos, un diagrama para mostrar uno en el panel de control.",
    "noLiveSystemAvailable": "Tiene que crear, al menos, un sistema a tiempo real con el fin de mostrar uno en el panel de control.",
    "noWeatherAvailable": "Tiene que crear, al menos, una localización con el fin de mostrar una en el panel de control.",
    "demoVisualisierung": "Visualizar demo",
    "ownVisualisierung": "Visualizar su equipo",
    "chooseComponent": "Seleccione un componente del panel de control",
    "addComponent": "Añadir nuevos componentes",
    "editComponent": "Editar componentes",
    "changeBackgroundColor": "Cambiar el color de fondo",
    "deleteAllComponents": "Borrar todos los componentes",
    "addComponentInfo": "Agregue nuevos componentes a su panel de control",
    "notAvailableInFullscreen": "¡No está disponible en modo de pantalla completa!",
    "reloadComponent": "Volver a cargar el componente",
    "deleteSelectedComponents": "Borrar los componentes seleccionados",
    "deselectAll": "Deseleccionar todo",
    "noImageAvailable": "",
    "notAllowedForSubscription": "",
    "removeThisComponent": "",
    "removeSelectedComponents": "",
    "load": "",
    "loadFromOtherDevice": "",
    "loadFromOtherDeviceInfo": "",
    "settings": "",
    "itemBorderTyp": "",
    "itemBorderNone": "",
    "itemBorder": "",
    "itemBorderShadow": "",
    "lockItems": "",
    "deleteQuestion": "",
    "delete": ""
  },
  "images": {
    "clickOnImageText": "Haga clic en la imagen que desea seleccionar.",
    "currentImage": "Imagen actual"
  },
  "enter": {
    "name": {
      "diagram": "Por favor, introduzca el nombre del diagrama",
      "filter": "Por favor, introduzca el nombre del filtro",
      "scheme": "Por favor, introduzca el nombre del esquema",
      "image": "Por favor, introduzca el nombre de la imagen"
    },
    "vbus": {
      "password": "Introduzca la contraseña de VBus y haga clic en SIGUIENTE…"
    }
  },
  "prepare": {
    "download": "Se están preparando los datos. Esta operación puede durar algunos minutos. Por favor, espere…"
  },
  "access": {
    "denied": "Acceso denegado"
  },
  "data": {
    "filter": "Filtros",
    "transmission": {
      "running": "Transferencia de datos en curso…"
    }
  },
  "genral": {
    "to": "Hasta"
  },
  "unselect": {
    "all": "Deseleccionar todo"
  },
  "my": {
    "account": "Mi cuenta de usuario",
    "diagrams": "Mis diagramas",
    "downloads": "Mis descargas",
    "schemes": "Mis pantallas de datos a tiempo real",
    "devices": "Mis equipos",
    "friends": "Usuarios con acceso a mis equipos.",
    "reports": "Mis informes"
  },
  "limitationText": {
    "noConfiguration": "No permite configurar el datalogger",
    "only90days": "Sólo están disponibles los datos grabados en los últimos 90 días",
    "onlyDemoDatalogger": "Sólo permite acceder al Datalogger de muestra"
  },
  "info": {
    "smallerLogInterval": "VBus.net no soporta los intervalos de grabación cortos ajustados en el datalogger.",
    "logInterval": "VBus.net memoriza los datos grabados por su datalogger RESOL a intervalos de 5 minutos como mínimo.",
    "clickToDelete": "Borrar: <i class=\"fa fa-trash-o clickToDelete\"></i>",
    "clickToEdit": "Editar: <i class=\"fa fa-edit clickToEdit\"></i>",
    "clickToMove": "Mover: <i class=\"fa fa-arrows-v clickToEdit\"></i>"
  },
  "modal": {
    "info": {
      "filter": "Si desea visualizar ciertos datos de su sistema, puede crear un <a class='link' href='/vbus/add-selector'>filtro</a> personalizado. Este aparecerá en la lista y podrá ser seleccionado."
    }
  },
  "discover": {
    "deviceDiscovery": "Device Discovery",
    "deviceDiscoveryWizard": "Device Discovery Wizard"
  },
  "unlocks": {
    "resendUnlockInstructions": "Enviarme de nuevo instrucciones para desbloquear cuenta"
  },
  "activerecord": {
    "errors": {
      "models": {
        "ownership": {
          "attributes": {
            "name": {
              "too_short": "es demasiado corta (mínimo: 6 carácteres)"
            }
          }
        }
      }
    }
  },
  "forward": {
    "toWebinterfaceOfDatalogger": "Redireccionando hacia la interfaz web del datalogger…",
    "notAllowedToAccessOwnership": "No tiene acceso a este equipo.",
    "textForwardedToWebInterface": "Si este equipo fuera suyo, usted sería redireccionado automáticamente hacia la interfaz web del mismo en pocos segundos. El datalogger de muestra no permite esta operación. Gracias por su comprensión.",
    "textLoginOtherCredentials": "Por favor, no olvide que los datos de acceso a la interfaz web del equipo no son los mismos que los datos de acceso a la cuenta VBus.net.",
    "textYouWillBeForwarded": "Usted está a punto de ser redireccionado hacia a la interfaz web de su equipo. Si esto no sucede, haga clic en el siguiente enlace.",
    "datenloggerLink": "Interfaz del equipo"
  },
  "paypal": {
    "buy": {
      "now": "Comprar ahora"
    },
    "order": {
      "text": "Esta operación puede durar un par de días.",
      "error": "Se ha producido un error al transmitir los datos a Paypal. Por favor, contacte con nuestro servicio de asistencia técnica en caso de no estar activado el servicio adicional que ha comprado. "
    }
  },
  "invalid": {
    "via_tag": "La etiqueta vía debe tener al menos 3 caracteres, comenzando con una letra minúscula. Puede contener caracteres de subrayado, números, guiones y letras minúsculas."
  },
  "incorrect": {
    "failure": {
      "already_activated": "Esta etiqueta vía ya está en uso. Por favor, elija otra."
    }
  },
  "selected": {
    "dataFields": "Campos de datos seleccionados"
  },
  "legend": {
    "description": "Leyenda",
    "layout": {
      "align": "Diseño",
      "horizontal": "Horizontal",
      "vertical": "Vertical"
    },
    "position": {
      "horizontal": "Posición horizontal",
      "vertical": "Posición vertical ",
      "left": "Izquierda",
      "central": "Centro",
      "right": "Derecha",
      "top": "Arriba",
      "bottom": "Parte inferior"
    }
  },
  "datapoint": {
    "selectedOne": "Punto de datos seleccionado",
    "selectedMore": "Puntos de datos seleccionados"
  },
  "information": {
    "minOneOwnership": "Para poder utilizar las funciones de visualización, tiene que añadir al menos un equipo o datalogger de muestra a su cuenta."
  },
  "tip": {
    "location": "Si usted indica una ubicación para el equipo, usted será capaz de acceder a los datos del tiempo en su panel de control. Introduzca las coordenadas de su sistema o la búsqueda para su ubicación."
  },
  "messages": {
    "tryGeodata": "Introduzca sus coordenadas directamente."
  },
  "get": {
    "professional": {
      "account": "Obtenga su acceso PRO ahora…"
    }
  },
  "one": {
    "year": {
      "vbus": {
        "professional": "1 año VBus.net PRO"
      }
    }
  },
  "register": {
    "subscribe": {
      "newsletter": "Deseo suscribirme a la newsletter RESOL."
    },
    "free": "Regístrese ahora gratis"
  },
  "homepage": {
    "greetingText": "El portal web para el acceso fácil y seguro a sus datos del sistema",
    "simpleText": "Fácil acceso en solo dos pasos:",
    "registerText": "<a href=\"#register\">Regístrese</a> ahora gratis a VBus.net ",
    "addDataloggerText": "Añadir su equipo a VBus.net",
    "initationText": "VBus.net es todo acerca de los datos de su regulador RESOL. Datos a tiempo real de su sistema, configuración de filtros personalizados y mucho más le esperan.",
    "dataViewerHeader": "RESOL VBus Data Viewer, integrado en VBus.net",
    "dataViewerInfo": "Visualizar los datos almacenados en una tarjeta SD con el RESOL VBus Data Viewer"
  },
  "errorLog": {
    "thankYou": "Gracias por enviarnos el informe de errores.",
    "ticketNumberText": "Su ticket tiene el siguiente número:"
  },
  "rerrorReport": {
    "helpText": "Ayudenos a mejorar el funcionamiento de VBus.net: comuníquenos cualquier error que se produzca cuando utilice VBus.net."
  },
  "friendshipToken": {
    "typeOfUse": "Uso",
    "useText": "Introduzca aquí un nombre para poder identificar el código de acceso (token) posteriormente. Así podrá saber con quien ha compartido su equipo. "
  },
  "cookies": {
    "name": "Cookies",
    "useVBusnet": "Para poder utilizar VBus.net se debe aceptar la política de cookies.",
    "description1": "Los cookies son pequeños archivos de texto que son guardados en su ordenador para una página web. Estos archivos, almacenan información sobre su última visita a dicha página web, su idioma preferido y más ajustes.",
    "description2": "VBus.net utiliza cookies exclusivamente para memorizar el idioma ajustado e información sobre su cuenta.",
    "furtherInformation": "Encontrará más información sobre cookies y su procesamiento en",
    "disclaimerExternalLinks": "Por favor, recuerde que no nos hacemos responsables del contenido de páginas web externas.",
    "privacyPolicy": "Encontrará más información sobre las cookies y su uso en"
  },
  "subscribe": {
    "maintenance": "Sí, deseo estar informado de las operaciones de mantenimiento por correo electrónico."
  },
  "title": {
    "help": "Ayuda"
  },
  "original": {
    "names": "Nombre orginal",
    "value": "Valor original"
  },
  "cookie": {
    "acceptText": "Política de Cookies"
  },
  "viaTag": {
    "useDefaultPassword": "Su equipo está accesible con su clave estándar!",
    "ChangePasswordText": "Por razones de seguridad, le aconsejamos que modifique la clave del equipo."
  },
  "lineChart": {
    "diagram": "Diagrama de líneas (absoluta)"
  },
  "barChart": {
    "diagram": "Diagrama de barras (resumen diario)"
  },
  "werbung": {
    "textDatenlogger": "¿Más información sobre nuestros Dataloggers / módulos de comunicación?",
    "textKommunikationsmodul": "¿Todavía no has descubierto nuestro módulo de comunicación?",
    "textSolarregler": "¿Conoces nuestros reguladores solares y de sistema DeltaSol®?",
    "textHeizungsregler": "¿Te gustaría aprender más acerca de nuestra familia de reguladores de calefacción?"
  },
  "notice": {
    "dataloggerTimeout": "Este dispositivo no ha estado entregando datos a tiempo real durante varios minutos...",
    "dataloggerInitialze": "Inicialización",
    "dataloggerInitialzeText": "Puede tardar unos minutos su dispositivo para inicializar...",
    "dataloggerInitialzed": "Su equipo ha completado la inicialización. Puede iniciar la visualización ahora."
  },
  "nextStep": {
    "step2": "Con el fin de crear un <b>Sistema a tiempo real</b>, necesita una __IMAGE__.",
    "step3": "Con el fin de crear un __DIAGRAM__ o un __LIVESYSTEM__.",
    "step4": "Crear una __DOWNLOAD__ de sus datos con el fin de tratar o analizarlos manualmente.",
    "step1": "Crear un __FILTER__ primero con el fin de crear un <b>esquema</b> o un <b>sistema a tiempo real</b>. <br/> Una <b>descarga</b> también puede optimizarse mediante un filtro."
  },
  "support": {
    "noDatafromDevice": "No se pueden recibir datos desde su equipo!.",
    "pleaseCheck": "Por favor, eche un vistazo en el manual del equipo y compruebe lo siguiente:",
    "checkPowerSupply": "Alimentación del router y el Datalogger / módulo de comunicación",
    "checkInternetConnection": "Conexión de internet",
    "checkConncectionToDevice": "Conexión del router al Datalogger/ módulo de comunicación",
    "checkManual": "Para más información, consulte el manual de instrucciones de su aparato.",
    "hintIntranet": "Para redes de empresa: los puertos 1194 y 1195 son bloqueados por el cortafuegos. Por favor, póngase en contacto con el administrador de la red.",
    "allowAccessToAccount": "",
    "token": "",
    "needHelp": "",
    "tokenRemove": "",
    "tokenCreate": "",
    "extended": ""
  },
  "areaChart": {
    "diagram": "Area del cuadro"
  },
  "userFeedback": {
    "helpUs": "",
    "takeTheSurvey": "",
    "question1": "",
    "question2": "",
    "question3": "",
    "question4": "",
    "question5": "",
    "question6": "",
    "question7": "",
    "question8": "",
    "question9": "",
    "question10": "",
    "question11": "",
    "question12": "",
    "question13": "",
    "submit": "",
    "simple": "",
    "complicated": "",
    "veryHelpful": "",
    "redundant": "",
    "notUsed": "",
    "excellent": "",
    "insufficient": "",
    "veryEasy": "",
    "extremelyComplex": "",
    "veryGood": "",
    "veryBad": "",
    "indispensable": "",
    "useless": "",
    "dontKnowYet": "",
    "price": "",
    "noAdditionalValue": "",
    "other": "",
    "daily": "",
    "weekly": "",
    "monthly": "",
    "lessThanMonth": "",
    "quietSure": "",
    "certainlyNot": "",
    "backToDashboard": "Volver al panel",
    "answerAllQuestions": "¡Por favor, conteste todas las preguntas marcadas con un<i class=\"fa fa-times\" aria-hidden=\"true\"></i>!",
    "extendedPro": "Su acceso PRO se ha ampliado por 30 días."
  },
  "dashboardMessage": {
    "changeViaTag": "Por razones técnicas, la etiqueta de extensión vía ha cambiado de <kbd>.via.vbus.net</kbd> a <kbd>.vbus.io</kbd>. Por favor adapte sus favoritos, si es necesario.<br><br>(Ejemplo: mydl2.via.vbus.net -> mydl2.vbus.io). No se requieren más ajustes."
  },
  "config": {
    "startWithout": "Empezar sin configuración",
    "empty": "vacío",
    "notLoadable": "no se puede cargar"
  },
  "check": {
    "completed": "Comprobación concluida…"
  },
  "waiting": {
    "running": {
      "tasks": "Finalizando los procesos en curso..."
    }
  },
  "dsgvo": {
    "Nutzungsbedingungen": "He leído y entendido los <a href=\"#register\" class=\"open-terms-of-use\">términos de uso</a> y los acepto.",
    "Datenschutzerklaerung": "He leído y entendido la <a href=\"#register\" class=\"open-privacy-policy\">pólítica de privacidad</a> y la acepto."
  },
  "pro": {
    "validUntil": "Acceso PRO válido hasta"
  },
  "channel": {
    "no": "N.º de canal"
  },
  "location": {
    "notFound": "¡No se ha encontrado ninguna ubicación!"
  },
  "faq": {
    "q1": "¿Cómo añado un aparato a VBus.net?",
    "a1": "Inicie una sesión en VBus.net. Abra el punto del menú Mis equipos y haga clic en Añadir un equipo. Introduzca el código de acceso/token de su aparato.",
    "q2": "¿Cómo puedo crear un informe de apoyo?",
    "a2_1": "Inicie una sesión en la interfaz web de KM2 y haga clic en Descargar en Estado -> Informe de apoyo.",
    "a2_2": "Guarde el archivo y envíelo a __EMAIL__.",
    "a2_3": "Abra la dirección IP del datalogger en el navegador e inicie una sesión en la interfaz web.",
    "a2_4": "Abra la URL http://[IP DEL APARATO]/dlx/support",
    "a2_5": "Aparece el enlace «Haga clic aquí para crear y descargar un informe de soporte técnico» con el que se ejecuta la descarga.",
    "q3": "Mi aparato está desconectado, ¿qué puedo hacer?",
    "a3": "Compruebe que su aparato está conectado a Internet. Si otros aparatos de la misma red no están conectados a Internet, puede que haya un problema con la conexión a Internet. Para que el aparato pueda acceder a VBus.net, el acceso a los puertos 80 y 1194/1195 no deberá estar restringido y no deberá estar bloqueado por un firewall.",
    "q4": "¿Tengo que pagar por VBus.net?",
    "a4": "VBus.net es gratuito en la versión básica. Puede visualizar su sistema y recibir datos en vivo cada 5 minutos. La versión PRO cuesta 39 € al año y ofrece además de las funciones básicas muchas posibilidades de monitoreo y funciones avanzadas de visualización. Además, la parametrización a través de WebRPT está incluida y sus datos en tiempo real se actualizan cada minuto.",
    "q5": "¿Cuál es la diferencia entre VBus.net Basic y PRO?",
    "a5": "Aquí puede encontrar una comparación de las diferentes versiones de VBus.net: __VERSIONSVERGLEICH__",
    "q6": "¿Es VBus.net compatible con el adaptador de interfaz VBus®/LAN?",
    "a6": "No, para conectar su regulador a VBus.net se requiere un módulo de comunicación KM2, datalogger DL2 o datalogger DL3.",
    "q7": "Mis diagramas se muestran incorrectamente, ¿qué puedo hacer?",
    "a7": "Compruebe si la zona horaria ajustada en Mis equipos está ajustada correctamente y corresponde a la ubicación del aparato. Compruebe también la zona horaria del propio aparato.",
    "q8": "¿Cuál es la contraseña para la parametrización?",
    "a8": "vbus",
    "title": "Respuestas a las preguntas más frecuentes",
    "hints": "Por favor, asegúrese de utilizar siempre un navegador actual. Si los problemas persisten, utilice un navegador diferente.",
    "notFound": "¿Todavía no se ha respondido a su pregunta? Entonces, póngase en contacto con nosotros en __LINK__.",
    "q9": "En un diagrama, hay etiquetas no utilizadas en el eje Y.",
    "a9": "El filtro utilizado en este diagrama debe guardarse de nuevo.",
    "q10": "",
    "a10": "",
    "q11": "",
    "a11": ""
  },
  "createImageFirst": "Primero debe crear una imagen...",
  "professinal": {
    "expiredOn": "¡El acceso PRO caducó el __VALID_UNTIL__!",
    "expireInfo": ""
  },
  "validation": {
    "positiveNumber": "Número positivo"
  },
  "reset": {
    "allEntries": "Borrar todas las entradas"
  },
  "fileSizeToBig": "¡El archivo es demasiado grande!",
  "controllerVersionChanged": "",
  "cantLoadConfigurations": "",
  "dl3NotSupported": "",
  "change": {
    "modulename": ""
  },
  "email": {
    "doNotReply": ""
  },
  "discoveryTool": {
    "title": "",
    "text": ""
  },
  "group": {
    "create": "",
    "edit": "",
    "delete": "",
    "deleteGroup": "",
    "neDeviceDelete": ""
  },
  "filterValue": {
    "add": "",
    "sub": "",
    "mul": "",
    "div": "",
    "conversionWithFilter": "",
    "linkedTo": ""
  },
  "errorSendingEmails": "",
  "errorSendingEmailConfirm": "",
  "confirmEmailServices": "",
  "keyboard": {
    "capsLockActive": ""
  },
  "firmware": {
    "title": "",
    "available": "",
    "downloadText": "",
    "deviceInstall": "",
    "acceptText": "",
    "alreadyAccepted": "",
    "activateAutomaticUpdate": ""
  }
}



// WEBPACK FOOTER //
// ./src/locales/mtf/es/index.js